/*!
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Script: jQuery throttle / debounce: Sometimes, less is more!
//
// *Version: 1.1, Last updated: 3/7/2010*
// 
// Project Home - http://benalman.com/projects/jquery-throttle-debounce-plugin/
// GitHub       - http://github.com/cowboy/jquery-throttle-debounce/
// Source       - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.js
// (Minified)   - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.min.js (0.7kb)
// 
// About: License
// 
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
// 
// About: Examples
// 
// These working examples, complete with fully commented code, illustrate a few
// ways in which this plugin can be used.
// 
// Throttle - http://benalman.com/code/projects/jquery-throttle-debounce/examples/throttle/
// Debounce - http://benalman.com/code/projects/jquery-throttle-debounce/examples/debounce/
// 
// About: Support and Testing
// 
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
// 
// jQuery Versions - none, 1.3.2, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome 4-5, Opera 9.6-10.1.
// Unit Tests      - http://benalman.com/code/projects/jquery-throttle-debounce/unit/
// 
// About: Release History
// 
// 1.1 - (3/7/2010) Fixed a bug in <jQuery.throttle> where trailing callbacks
//       executed later than they should. Reworked a fair amount of internal
//       logic as well.
// 1.0 - (3/6/2010) Initial release as a stand-alone project. Migrated over
//       from jquery-misc repo v0.4 to jquery-throttle repo v1.0, added the
//       no_trailing throttle parameter and debounce functionality.
// 
// Topic: Note for non-jQuery users
// 
// jQuery isn't actually required for this plugin, because nothing internal
// uses any jQuery methods or properties. jQuery is just used as a namespace
// under which these methods can exist.
// 
// Since jQuery isn't actually required for this plugin, if jQuery doesn't exist
// when this plugin is loaded, the method described below will be created in
// the `Cowboy` namespace. Usage will be exactly the same, but instead of
// $.method() or jQuery.method(), you'll need to use Cowboy.method().

(function(window,undefined){
  '$:nomunge'; // Used by YUI compressor.
  
  // Since jQuery really isn't required for this plugin, use `jQuery` as the
  // namespace only if it already exists, otherwise use the `Cowboy` namespace,
  // creating it if necessary.
  var $ = window.jQuery || window.Cowboy || ( window.Cowboy = {} ),
    
    // Internal method reference.
    jq_throttle;
  
  // Method: jQuery.throttle
  // 
  // Throttle execution of a function. Especially useful for rate limiting
  // execution of handlers on events like resize and scroll. If you want to
  // rate-limit execution of a function to a single time, see the
  // <jQuery.debounce> method.
  // 
  // In this visualization, | is a throttled-function call and X is the actual
  // callback execution:
  // 
  // > Throttled with `no_trailing` specified as false or unspecified:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // > X    X    X    X    X    X        X    X    X    X    X    X
  // > 
  // > Throttled with `no_trailing` specified as true:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // > X    X    X    X    X             X    X    X    X    X
  // 
  // Usage:
  // 
  // > var throttled = jQuery.throttle( delay, [ no_trailing, ] callback );
  // > 
  // > jQuery('selector').bind( 'someevent', throttled );
  // > jQuery('selector').unbind( 'someevent', throttled );
  // 
  // This also works in jQuery 1.4+:
  // 
  // > jQuery('selector').bind( 'someevent', jQuery.throttle( delay, [ no_trailing, ] callback ) );
  // > jQuery('selector').unbind( 'someevent', callback );
  // 
  // Arguments:
  // 
  //  delay - (Number) A zero-or-greater delay in milliseconds. For event
  //    callbacks, values around 100 or 250 (or even higher) are most useful.
  //  no_trailing - (Boolean) Optional, defaults to false. If no_trailing is
  //    true, callback will only execute every `delay` milliseconds while the
  //    throttled-function is being called. If no_trailing is false or
  //    unspecified, callback will be executed one final time after the last
  //    throttled-function call. (After the throttled-function has not been
  //    called for `delay` milliseconds, the internal counter is reset)
  //  callback - (Function) A function to be executed after delay milliseconds.
  //    The `this` context and all arguments are passed through, as-is, to
  //    `callback` when the throttled-function is executed.
  // 
  // Returns:
  // 
  //  (Function) A new, throttled, function.
  
  $.throttle = jq_throttle = function( delay, no_trailing, callback, debounce_mode ) {
    // After wrapper has stopped being called, this timeout ensures that
    // `callback` is executed at the proper times in `throttle` and `end`
    // debounce modes.
    var timeout_id,
      
      // Keep track of the last time `callback` was executed.
      last_exec = 0;
    
    // `no_trailing` defaults to falsy.
    if ( typeof no_trailing !== 'boolean' ) {
      debounce_mode = callback;
      callback = no_trailing;
      no_trailing = undefined;
    }
    
    // The `wrapper` function encapsulates all of the throttling / debouncing
    // functionality and when executed will limit the rate at which `callback`
    // is executed.
    function wrapper() {
      var that = this,
        elapsed = +new Date() - last_exec,
        args = arguments;
      
      // Execute `callback` and update the `last_exec` timestamp.
      function exec() {
        last_exec = +new Date();
        callback.apply( that, args );
      };
      
      // If `debounce_mode` is true (at_begin) this is used to clear the flag
      // to allow future `callback` executions.
      function clear() {
        timeout_id = undefined;
      };
      
      if ( debounce_mode && !timeout_id ) {
        // Since `wrapper` is being called for the first time and
        // `debounce_mode` is true (at_begin), execute `callback`.
        exec();
      }
      
      // Clear any existing timeout.
      timeout_id && clearTimeout( timeout_id );
      
      if ( debounce_mode === undefined && elapsed > delay ) {
        // In throttle mode, if `delay` time has been exceeded, execute
        // `callback`.
        exec();
        
      } else if ( no_trailing !== true ) {
        // In trailing throttle mode, since `delay` time has not been
        // exceeded, schedule `callback` to execute `delay` ms after most
        // recent execution.
        // 
        // If `debounce_mode` is true (at_begin), schedule `clear` to execute
        // after `delay` ms.
        // 
        // If `debounce_mode` is false (at end), schedule `callback` to
        // execute after `delay` ms.
        timeout_id = setTimeout( debounce_mode ? clear : exec, debounce_mode === undefined ? delay - elapsed : delay );
      }
    };
    
    // Set the guid of `wrapper` function to the same of original callback, so
    // it can be removed in jQuery 1.4+ .unbind or .die by using the original
    // callback as a reference.
    if ( $.guid ) {
      wrapper.guid = callback.guid = callback.guid || $.guid++;
    }
    
    // Return the wrapper function.
    return wrapper;
  };
  
  // Method: jQuery.debounce
  // 
  // Debounce execution of a function. Debouncing, unlike throttling,
  // guarantees that a function is only executed a single time, either at the
  // very beginning of a series of calls, or at the very end. If you want to
  // simply rate-limit execution of a function, see the <jQuery.throttle>
  // method.
  // 
  // In this visualization, | is a debounced-function call and X is the actual
  // callback execution:
  // 
  // > Debounced with `at_begin` specified as false or unspecified:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // >                          X                                 X
  // > 
  // > Debounced with `at_begin` specified as true:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // > X                                 X
  // 
  // Usage:
  // 
  // > var debounced = jQuery.debounce( delay, [ at_begin, ] callback );
  // > 
  // > jQuery('selector').bind( 'someevent', debounced );
  // > jQuery('selector').unbind( 'someevent', debounced );
  // 
  // This also works in jQuery 1.4+:
  // 
  // > jQuery('selector').bind( 'someevent', jQuery.debounce( delay, [ at_begin, ] callback ) );
  // > jQuery('selector').unbind( 'someevent', callback );
  // 
  // Arguments:
  // 
  //  delay - (Number) A zero-or-greater delay in milliseconds. For event
  //    callbacks, values around 100 or 250 (or even higher) are most useful.
  //  at_begin - (Boolean) Optional, defaults to false. If at_begin is false or
  //    unspecified, callback will only be executed `delay` milliseconds after
  //    the last debounced-function call. If at_begin is true, callback will be
  //    executed only at the first debounced-function call. (After the
  //    throttled-function has not been called for `delay` milliseconds, the
  //    internal counter is reset)
  //  callback - (Function) A function to be executed after delay milliseconds.
  //    The `this` context and all arguments are passed through, as-is, to
  //    `callback` when the debounced-function is executed.
  // 
  // Returns:
  // 
  //  (Function) A new, debounced, function.
  
  $.debounce = function( delay, at_begin, callback ) {
    return callback === undefined
      ? jq_throttle( delay, at_begin, false )
      : jq_throttle( delay, callback, at_begin !== false );
  };
  
})(this);

var searchResultsNumberVisible = true;


var finalProducts = [];
var finalProductsData = [];
var algoliaModel = '';
var algoliaModelProper = '';

// Women's products are already split into their own search tab, so that badge
// would be redundant over every hit in it.
var searchBadgesExcludedTags = ['dev-product-type-women'];

(function ($) {

  'use strict';

  let showSuggestions = false;

  var aldsearch = {
    init: function() {
      aldsearch.loadYmal();
      aldsearch.attachEvents();
      aldsearch.triggerSearchOnSearchPage();
    },

    // "You may also like" (Algolia recommendations). Extracted from init() so the PDP
    // colour-swatch quick-swap can rebuild it for the newly selected product. Re-callable:
    // objectIDs / filtersQuery are read from the DOM (#add-item-form, .product__infolabel),
    // and it appends into .you-may-also-like-products, which the swap re-renders empty first.
    loadYmal: function() {

      // These live at module scope and are appended to as hits are rendered. loadYmal() is
      // re-callable (the PDP colour swap rebuilds YMAL per colour), so without this reset the
      // arrays grow with every call and the /api/product_info POST carries every product seen
      // so far, duplicates included — observed going 10 -> 17 -> 23 ids over two swatch clicks.
      finalProducts = [];
      finalProductsData = [];

      $('.search-reults--number').show()

      var prefix = 'US';
      if(window.location.href.indexOf('eu.') > -1) {
        prefix = 'EU';
      }

      var objectIDs = '';

      var runYmal = true;
      if($('form.cart .cart-item').length == 0 && $('body').hasClass('template-cart')) {
        runYmal = false;
      }

      if($('form.cart .cart-item').length) {
        objectIDs = $('form.cart .cart-item').eq(0).data('id')+''
      } else {
        if($('body').hasClass('template-name-jewelry')) {
          objectIDs = $('#product-form-id').val();
        } else {
          objectIDs = $('#add-item-form .swatch-size option').eq(1).val()
        }
      }

      var filtersQuery = 'NOT tags:hidden2020 AND NOT tags:vintage_search AND NOT tags:dev-jewelry-secondary AND NOT tags:dev-bypass-product-secondary AND NOT tags:a_invite_only AND NOT tags:dev-in-store-only';
      if($('.product__infolabel').length) {
        if($('.product__infolabel').eq(0).text() == "Women's") {
          filtersQuery += ' AND tags:dev-product-type-women'
        } else {
          filtersQuery += ' AND NOT tags:dev-product-type-women'  
        }
      } else {
        if($('form.cart .cart-item').length) {
          var cartItems = $('.cart-item').length;
          var womenItems = $('.cart-item[data-division=women]').length;
          var menItems = $('.cart-item[data-division=men]').length;
          console.log('cart div', cartItems, womenItems, menItems);
          if(womenItems > 0 && cartItems == womenItems) {
            filtersQuery += ' AND tags:dev-product-type-women'
          } else if(menItems > 0 && cartItems == menItems) {
            filtersQuery += ' AND NOT tags:dev-product-type-women' 
          } else {
            
          }
        } else {
          filtersQuery += ' AND NOT tags:dev-product-type-women'
        }
      }

      
        algoliaModel = 'trending-items';
        var requestData = {
          indexName: prefix + "Prod_products",
          model: algoliaModel,
          maxRecommendations: 30,
          threshold: 0,
          queryParameters: {
            filters: filtersQuery
          }
        }
      

      

      
        algoliaModel = 'related-products';
        var requestData = {
          indexName: prefix + "Prod_products",
          model: algoliaModel,
          maxRecommendations: 30,
          threshold: 0,
          objectID: objectIDs,
          queryParameters: {
            filters: filtersQuery
          }
        }
      

      algoliaModelProper = algoliaModel == 'bought-together' ? 'Frequently Bought Together' : 'Trending Items';
      
      
      algoliaModelProper = 'Related Products';
      

       var data = {
          requests: [
            requestData
          ],
        }

        if(window.location.href.indexOf('/products/') > -1 || window.location.href.indexOf('/cart') > -1) {
          if(runYmal) {
            $('.see-more-products').on('click', function() {
              if($(this).hasClass('see-less')) {
                $(this).removeClass('see-less');
                $(this).text('see more');
                $('.ymal-extra').addClass('ymal-hidden')
              } else {
                $(this).addClass('see-less');
                $(this).text('see less');
                $('.ymal-extra').removeClass('ymal-hidden')

                if (typeof gtag === 'function') {
                  if(window.location.href.indexOf('/products/') > -1) {
                    var type = $('#producttype').val();
                    gtag('event', `PDP_You May Also Like_${algoliaModelProper}_See More_${type}`);
                  }
                  if(window.location.href.indexOf('/cart') > -1) {
                    gtag('event', `Cart_You May Also Like_${algoliaModelProper}_See More`);
                  }
                }
              }
            });

            $.ajax({
              url: 'https://KD8QO388XF-dsn.algolia.net/1/indexes/*/recommendations',
              type: 'POST',
              headers: {
                'x-algolia-application-id': 'KD8QO388XF',
                'x-algolia-api-key': '276afc6221b469815636351357773c8e'
              },
              data: JSON.stringify(data),
              success: function(response) {

              var products = response.results[0];

              var storedProductsArray = [];

              if(localStorage.getItem('recentlyViewed') === null) {
                localStorage.setItem('recentlyViewed', '');
              } else {
                storedProductsArray = localStorage.getItem('recentlyViewed').split(',');
              }
              var cleanProductsArray = [];
              // clear nbhits from recently viewed
              for(var i in products.hits) {
                var duplicate = false
                for(var j in storedProductsArray) {
                  if(parseInt(products.hits[i].id) == parseInt(storedProductsArray[j])) {
                    duplicate = true;
                  }
                }
                if(duplicate == false) {
                  cleanProductsArray.push(products.hits[i])
                }
              }

              if($('form.cart .cart-item').length) {
                var cartProductIds = [];
                $('form.cart .cart-item').each(function() {
                  cartProductIds.push($(this).data('productid'));
                });
                cleanProductsArray = cleanProductsArray.filter(function(el) {
                  return cartProductIds.indexOf(el.id) < 0;
                })

              }

              

              
              cleanProductsArray = reorderRecommendProducts(cleanProductsArray);
              

              cleanProductsArray = cleanProductsArray.filter(function(el) {
                if(el.meta.algoliasearch !== undefined) {
                  if(el.meta.algoliasearch.markets !== undefined) {
                    additionalData = JSON.parse(el.meta.algoliasearch.markets);

                    if(location.href.indexOf('eu.') == -1) {
                      warehouseAvail = additionalData.warehouseAvailability.us;
                    } else {
                      if($('body').attr('data-country') == 'GB') {
                        warehouseAvail = additionalData.warehouseAvailability.uk;
                      } else {
                        warehouseAvail = additionalData.warehouseAvailability.eu;
                      }
                    }
                  }
                }
                return warehouseAvail != 'unavailable';
              })
                if(products.nbHits > 0 && cleanProductsArray.length > 0) {
                  var searchCounter = 0;
                  var searchResultsModified = false;

                    // hide the other half of products
                    var searchLimit = 16
                    if($(window).width() <= 1024) {
                      searchLimit = 8
                    }
    var superCounter = 0;
                  for(var i in cleanProductsArray) {
                    superCounter++;
                    var product = cleanProductsArray[i];
                    var productPrice = product.price;
                    var price = product.price;
                    var additionalData = '';
                    var secondaryImage = '';
                    var finalprice = '';
                    var warehouseAvail = '';
                    var priceToDisplay = '';
                    var classCompare = '';
                    var finalPrice = '';

                    var productAlt = '';

                    if(product.meta.algoliasearch !== undefined) {
                      if(product.meta.algoliasearch.markets !== undefined) {
                        additionalData = JSON.parse(product.meta.algoliasearch.markets);
                        secondaryImage = additionalData.secondary_image;

                        productAlt = additionalData.images[0].alt;

                        if(location.href.indexOf('eu.') == -1) {
                          warehouseAvail = additionalData.warehouseAvailability.us;
                        } else {
                          if($('body').attr('data-country') == 'GB') {
                            warehouseAvail = additionalData.warehouseAvailability.uk;
                          } else {
                            warehouseAvail = additionalData.warehouseAvailability.eu;
                          }
                        }

                        if(additionalData.marketprices !== undefined) {
                          var currentLocale = Shopify.country;
                          var marketprice = additionalData.marketprices[currentLocale].price;
                          var marketcurrency = additionalData.marketprices[currentLocale].currency;
                          price = formatPrice(marketprice, marketcurrency);

                          var compareAtPrice = price;

                          if(additionalData.marketprices[currentLocale].compare_at_price !== null) {
                            compareAtPrice = additionalData.marketprices[currentLocale].compare_at_price;
                          } else {
                            compareAtPrice = 0;
                          }
                          var priceToDisplay = '';
                          var classCompare = '';

                          finalprice += '<span class="money">'+price+'</span>';
                          if(marketprice < compareAtPrice && compareAtPrice != 0) {
                            compareAtPrice = formatPrice(compareAtPrice, marketcurrency);
                            finalprice += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                            classCompare = 'plp-product__price--compare';
                          }
                        }

                      }
                    }


  if(warehouseAvail == 'available') {
                    if(location.href.indexOf('eu.') != -1) {
                      if(Shopify.country == 'GB' && product.tags.indexOf('dev-algolia-hide-uk') > -1) {
                        searchResultsModified = true;
                        continue;
                      } else if(Shopify.country != 'GB' && product.tags.indexOf('dev-algolia-hide-eu') > -1) {
                        searchResultsModified = true;
                        continue;
                      } else {
                        searchCounter++;
                      }
                    } else {
                      searchCounter++;
                    }

                    finalProducts.push(product.id);

                    if(searchCounter == (searchLimit+1) && window.location.href.indexOf('/search') == -1) {
                      break;
                    } else {
                      finalProductsData.push(product)
                    }

                    var customTag = '';

                    if(secondaryImage === '') {
                      secondaryImage = product.product_image;
                    }


                    if(product.id == 7227129888865) {
                      secondaryImage = 'https://cdn.shopify.com/s/files/1/0302/7829/files/GIFTCARD_7287.jpg?v=1730322305'
                    }


                    if(warehouseAvail != 'available' && product.inventory_policy != 'continue') {
                      finalprice = 'SOLD OUT'
                    }

                    if(warehouseAvail == 'available') {
                      if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">Reserve</div>';
                      }
                      if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
                      }
                      if(product.tags.indexOf('NEW_PRODUCT') > -1 || product.tags.indexOf('new_product') > -1) {
                        customTag = '<div class="plp-product__tag">NEW</div>  ';
                      }
            if(product.tags.indexOf('dev-product-type-women') > -1) {
              customTag = '<div class="plp-product__tag plp-product__tag--nocaps">Women\'s</div>  ';
            }
                    } else {
                      if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
                        finalprice = 'RESERVATIONS FULL';
                      }
                      if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
                        finalprice = 'ENTER THE DRAW';
                      }
                      if(product.tags.indexOf('dev-in-store-only') > -1) {
                        if(product.meta.InStoreLabel !== undefined) {
                          finalprice = product.meta.InStoreLabel.label.replaceAll(' ', '&nbsp;');
                        } else {
                          finalprice = 'IN&nbsp;STORE&nbsp;ONLY';
                        }  
                      }
                      if(product.tags.indexOf('dev-coming-soon') > -1) {
                        finalprice = 'COMING SOON';
                      }
            if(product.tags.indexOf('dev-product-type-women') > -1) {
              customTag = '<div class="plp-product__tag plp-product__tag--nocaps">Women\'s</div>  ';
            }
            // if(product.tags.indexOf('dev-product-type-women') > -1) {
            //   customTag = '<div class="plp-product__tag plp-product__tag--nocaps">Women\'s</div>  ';
            // }
                    }

                    if(product.id == 6702926626913) {
                      finalprice = '$50 - $1000';
                    }

                    if(product.tags.indexOf('dev-hide-product-price') > -1) {
                      finalprice = '';
                    }

                    var additionalClass = '';
                    if(searchCounter > (searchLimit/2)) {
                      additionalClass = 'ymal-extra ymal-hidden';
                    }

                    $('.you-may-also-like-products').append(`
                      <a tabindex="0" id="upsellymal-${product.id}" data-scounter="${superCounter}" data-color="${product.options.color}" xhref="/products/${product.handle}" class="ymal-toggle plp-product ${additionalClass}">
                        <div class="image-4-5 product-image">
                          ${customTag}
                          <img src="${secondaryImage}&width=600" alt="${productAlt}" />
                        </div>
                        <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">
                          <h3 class="plp-product__title">${product.title}</h3>
                          <div class="plp-product__price ${classCompare}">
                              ${finalprice}
                          </div>
                        </div>
                      </a>
                    `)
  }
                  }

                  // finalProducts.splice(-1);

    /// begin render

                var store = 'aime-leon-dore';
                if(window.location.host.indexOf('eu') > -1) {
                  store = 'aime-leon-dore-eu';
                }
                if(window.location.host.indexOf('dev') > -1) {
                  store = 'aime-leon-dore-dev-store';
                }
                if(window.location.host.indexOf('eu-dev') > -1) {
                  store = 'aime-leon-dore-eu-dev';
                }

          var dataToSend = {
            'store_name': store,
            'product_ids': finalProducts,
            'iso_code': Shopify.country,
            // 'location_id': 68178706569
            // 'location_ids': [35407921289, 68178706569]
          }

          if(window.location.host.indexOf('eu') > -1) {
            var locationId = 50003247253;
            if($('body').attr('data-country') == 'GB') {
              locationId = 74146152597;
            }

            var dataToSend = {
              'store_name': store,
              'product_ids': finalProducts,
              'iso_code': Shopify.country,
              'location_ids': [locationId]
            }
          }

        if(finalProducts.length > 0) {
          $.ajax({
            url: 'https://api.aimeleondore.com/api/product_info',
            type: 'POST',
            data: JSON.stringify(dataToSend),
            accept: 'application/json',
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            success: function(response) {
              var counter = 1;
              for(var i in response) {
                if(response[i].product_id !== undefined) {
                  // if(counter < 9) {
                    if(response[i].sold_out != true && response[i].tags.indexOf('RAFFLE_PRODUCT') < 0 && response[i].tags.indexOf('dev-in-store-only') < 0) {
                      // if(response[i].tags.indexOf('a_ss25_drop1') > -1) {

                      var product = response[i];
                      // TODO should be local_price
                      var price = formatPrice(response[i].local_price.price, response[i].local_price.currency);
                      // var price = formatPrice(response[i].price, 'USD');
                      var compareAtPrice = price;

                      if(response[i].local_price.compare_at_price !== null) {
                        compareAtPrice = response[i].local_price.compare_at_price;
                      } else {
                        compareAtPrice = 0;
                      }
                      var priceToDisplay = '';
                      var classCompare = '';

                      priceToDisplay += '<span class="money">'+price+'</span>';
                      if(response[i].local_price.price < compareAtPrice && response[i].local_price.compare_at_price != 0) {
                        compareAtPrice = formatPrice(response[i].local_price.compare_at_price, response[i].local_price.currency);
                        priceToDisplay += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                        classCompare = 'plp-product__price--compare';
                      }

                      var images = '';
                      for(var j in response[i].images) {
                        if(j != 0) {
                          if(response[i].images[j].alt != 'dev-product-image-swatch') {
                            images += `                    <div class="swiper-slide upsell-carousel__item">
                              <img src="${response[i].images[j].url}&width=600" alt="${response[i].images[j].alt}" />
                            </div>`
                          }
                        }
                      }
                      var sizes = '<select class="custom-select" name="sizes-'+product.product_id+'">';

                      var swatchesMobile = '<option value="">Select Color</option>';
                      var swatches = '';
                      var swatchesIds = '';
                      for(var z in response[i].handles_info) {

                        var swatchData = response[i].handles_info[z];
                        var swatchHandle = Object.keys(swatchData);
                        var swatchId = Object.values(swatchData);
                        swatchesIds += Object.values(swatchData) + ',';

                        if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                          swatchesIds = uniqueJewelrySwatchIds();
                        }

                        var selected = '';
                        var selectedClass = '';
                        if(response[i].product_id == swatchId) {
                          selected = 'selected';
                          selectedClass = 'swatch-colors__item--selected';
                        }

                        swatches += `<a href="/products/${swatchHandle}" class="swiper-slide ${selectedClass} swatch-colors__item upsell-toggle" id="${product.product_id}" new="" data-swatchid="${swatchId}" data-swatchids="${swatchesIds}">
                                  <div class="image-square product-image">
                                  </div>
                                </a>`

                        var colors = response[i].handles[0];
                        colors = Object.values(colors);
                        colors = colors[0];

                        if(typeof colors === 'string') {
                          colors = colors.replace(/\([^)]*\)/g, '').split(',').map(function(entry) {
                            return entry.trim();
                          }).filter(function(entry) {
                            return entry !== '';
                          });
                        }

                        colors = colors[z];
                        swatchesMobile += `<option ${selected} data-img="" data-handle="" data-swatchid="${swatchId}">${colors}</option>`
                      }

                      if(response[i].handles_info == null) {
                        swatchesMobile = `<option selected data-img="${response[i].image_url}&width=100" data-handle="" data-swatchid="">${response[i].variants[0].color}</option>`;
                      }

                      swatchesIds = swatchesIds.slice(0, -1);

    /*
    
    */

                      const shipDelaySku = response[i].metafields?.find(mf => mf.ship_delay_skus)?.ship_delay_skus || '';
                      const shipDelayMessage = response[i].metafields?.find(mf => mf.ship_delay_message)?.ship_delay_message || '';

                      if(response[i].variants.length == 1) {
                        sizes += '<option value=""></option>';
                        const singleHasDelay = shipDelaySku.indexOf(response[i].variants[0].sku) > -1 && !response[i].variants[0].sold_out;
                        const singleDelayAttr = ` data-ship-delay="${singleHasDelay}" data-ship-delay-message="${shipDelayMessage}"` +
                          // Tier number only -- the copy lives in window.ALDLowStock and the unit
                          // count never leaves the backend. '' when the API returns null, or when
                          // an older build of it omits the field entirely.
                          ` data-low-stock-tier="${response[i].variants[0].low_stock_tier ?? ''}"`;
                        if(response[i].variants[0].sold_out) {
                          sizes += `<option class="disabled-el" data-soldout="${response[i].variants[0].sold_out}"${singleDelayAttr} value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                        } else {
                          sizes += `<option data-soldout="${response[i].variants[0].sold_out}" selected${singleDelayAttr} value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                        }
                      } else {
                        for(var k in response[i].variants) {
                          sizes += '<option value=""></option>';
                          const variantHasDelay = shipDelaySku.indexOf(response[i].variants[k].sku) > -1 && !response[i].variants[k].sold_out;
                          const delayAttr = ` data-ship-delay="${variantHasDelay}" data-ship-delay-message="${shipDelayMessage}"` +
                            // Tier number only -- the copy lives in window.ALDLowStock and the unit
                            // count never leaves the backend. '' when the API returns null, or when
                            // an older build of it omits the field entirely.
                            ` data-low-stock-tier="${response[i].variants[k].low_stock_tier ?? ''}"`;
                          if(response[i].variants[k].sold_out) {
                            sizes += `<option class="disabled-el" data-soldout="${response[i].variants[k].sold_out}"${delayAttr} value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                          } else {
                            sizes += `<option data-soldout="${response[i].variants[k].sold_out}"${delayAttr} value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                          }
                        }
                      }

                      sizes += '</select>';

                      var sizesMobile = '';
                      var showSelectOptions = 'd-none';
                      var showAddToCart = '';
                      var jewelryClass = '';
                      if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                        jewelryClass = 'chain-selector';
                        showSelectOptions = 'd-block';
                        showAddToCart = 'd-none d-lg-block';
                        sizes = $('.chain-select')[0].outerHTML;
                        // sizes = '<select class="custom-select" disabled><option>One Size</option></select>'

                        swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

                        swatchesMobile = $('.pendant-select')[0].innerHTML;
                      }

                      var colorName = response[i].variants[0].color;
                      var customTag = '';

                      if(response[i].tags.indexOf('PREORDER_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">Reserve</div>';
                      }
                      if(response[i].tags.indexOf('NEW_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">NEW</div>  ';
                      }

                      var productLimited = false;
                      var productQuantityLimitNumber = 0;
                      if(response[i].tags.indexOf('dev-qty-limit') > -1) {
                        productLimited = true;
                        productQuantityLimitNumber = response[i].tags.substring(response[i].tags.indexOf('dev-qty-limit')+14, response[i].tags.indexOf('dev-qty-limit')+15);
                      }

                      $('.recently-viewed').show();

                      $('#upsellymal-'+product.product_id).attr('data-swatchids', swatchesIds);

                      // $('.recently-viewed-carousel .swiper-wrapper').append(`       <div class="swiper-slide recently-viewed-carousel__item" data-swatchids="${swatchesIds}">
                      //   <a id="upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" class="product-image image-4-5 upsell-toggle">
                      //     ${customTag}
                      //     <img src="${product.images[1].url}&width=600" alt="" />
                      //   </a>
                      //   <div class="short-desc plp-product__details">
                      //     <h3 class="plp-product__title"><a href="#" class="upsell-toggle" id="upsell-${product.product_id}">${product.title}</a></h3>
                      //     <div class="plp-product__price ${classCompare}">
                      //       ${priceToDisplay}
                      //     </div>
                      //   </div>
                      // </div>`);

                      var addToBag = 'Add To Bag';
                      if(product.sold_out) {
                        addToBag = 'Notify Me';
                      }

                      $('.cart-upsell-container').append(`<div class="cart-upsell ymal-upsell" data-color="${colorName}" data-productid="${product.product_id}" data-limited="${productLimited}" data-limit-val="${productQuantityLimitNumber}" data-variantid="${product.variants[0].id}" id="popup-upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" data-swatchids="${swatchesIds}">
                        <button class="close-upsell d-none" aria-label="Close product details"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 15L15 1M1 1L15 15" stroke="#181818" stroke-width="2" aria-hidden="true"/>
                        </svg></button>
                        <div class="upsell-carousel">
                          <div class="swiper-wrapper">
                            ${images}
                          </div>
                        </div>

                        <div class="upsell-content product">
                          <h2 class="product__title">${product.title}</h2>
                          <div class="product__price  ${classCompare}" data-price="${response[i].local_price.price}">${priceToDisplay}</div>
                          <div class="product__variants product__variants--colors d-none d-lg-block">
                            <div class="product-variants-title d-none d-lg-block">
                              Color: ${colorName}
                            </div>
                            <div class="swatch-colors swiper-container">
                              <div class="swiper-wrapper">
                                ${swatches}
                              </div>
                            </div>
                            <div id="swatch-colors-next" class="swiper-btn-next"></div>
                            <div id="swatch-colors-prev" class="swiper-btn-prev"></div>
                          </div>

                          <form class="upsell-form">
                            <div class="random-div d-flex justify-content-between d-lg-block">
                              <div class="product__variants--colors d-lg-none">
                                <div class="custom-select-wrapper">
                                  <select class="custom-select">
                                    ${swatchesMobile}
                                  </select>
                                </div>
                              </div>

                              <div class="swatch-size swatch-size3 custom-select-wrapper ${showSelectOptions} d-lg-none">
                                <select class="custom-select" disabled>
                                  <option val="">One Size</option>
                                </select>
                              </div>

                              <div class="swatch-size swatch-size4 custom-select-wrapper ${jewelryClass} ${showAddToCart}" id="sizes-${product.product_id}">
                                  ${sizes}
                              </div>
                            </div>
                            <div class="atc-box">
                              <button name="add" id="select-options" type="button" class="select-options btn btn--dark btn--bag ${showSelectOptions} d-lg-none">Select Options</button>
                              <button name="add" id="add-submit" type="submit" class="btn btn--dark btn--bag ${showAddToCart} btn-upsell-add upsell-ymal-add btn-upsell-add--ymal">${addToBag}</button>
                              <div class="notify">
                                  <h4 class="notify__txt">Notify me when this product is in stock </h4>
                                  <div class="form-group" style="margin-bottom: 8px; margin-top: 13px;">
                                    <input type="email" id="notify_email" placeholder="Enter your email" name="EMAIL" class="notifyme-control form-control form-control--border" required>
                                  </div>
                                  <input type="button" id="notify" class="btn btn--dark" value="Submit" />
                                  <p class="notify-success-message btn btn--light" style="display: none;">you're on the list</p>

                                  <div class="bis-newsletter-signup">
                                    <input type="checkbox" checked id="bis-newsletter" name="bis-newsletter" class="bis-custom-checkbox">
                                    <label for="bis-newsletter"><span class="bn-out"><span class="bn-in"></span></span><span class="bn-txt">Sign me up for the mailing list</span></label>
                                    <div class="global-privacy-notice-element-small">By providing your email address, you agree to our <a href="${privacyPolicyFileLink}" target="blank">Privacy Policy</a>.</div>
                                  </div>
                              </div>
                              <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn upsell-ymal-btn">FULL DETAILS</a>
                            </div>
                          </form>
                        </div>
                      </div>`);

                      counter++;
                      // }
                    }
                  // }
                }
              }

              if(counter == 1) {
                $('.section-cart').addClass('no-recently-viewed');
              }

              if($(window).width() <= 1024) {
                if(counter <= 5) {
                  $('.see-more').remove();
                }
              } else {
                if(counter <= 9) {
                  $('.see-more').remove();
                }
              }

              if($('.upsell-carousel').length) {

              var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
              // if(isSafari || getOS() == 'Mac OS') {

              if(window.innerWidth > 1024) {
                var height = window.innerHeight;
                var imgHeight = height - 340;
                var width = Math.floor((4 * imgHeight) / 5);
                $('.upsell-carousel, .cart-upsell').width(width);
                if(width > 493) {
                  $('.upsell-carousel img').width('100%');
                } else {
                  $('.upsell-carousel img').width('');
                }
              } else {
                $('.upsell-carousel, .cart-upsell').width('');
              }

                var upsellCarousel = new Swiper('.upsell-carousel', {
                  spaceBetween: 7,
                  slidesPerView: 'auto',
                  breakpoints: {
                    1025: {
                      slidesPerView: 1,
                      spaceBetween: 0,
                      watchOverflow: true,
                    }
                  },
                  on: {
                    slideChange: function () {
                      var newIndex = this.activeIndex;
                      if (typeof gtag === 'function') {
                        var sku = $('.cart-upsell-collapse').data('productid');
                        if($('.cart-upsell-collapse').hasClass('ymal-upsell')) {
                          var prefix = 'US';
                          if(window.location.href.indexOf('eu.') > -1) {
                            prefix = 'EU';
                          }
                          var color = $('.cart-upsell-collapse').data('color');
                          if(window.location.href.indexOf('/products/') > -1) {
                            var type = $('#producttype').val();
                            // PDP_You May Also Like_[Index]_Quickview_Image Swipe_[Image Position]_[PDP Product Type]_[Product id]_[Color]
                            gtag('event', `PDP_You May Also Like_${window.algoliaModelProper}_Quickview_Image Swipe_${newIndex + 1}_${type}_${sku}_${color}`);
                          } else {
                            // Cart_You May Also Like_[Index]_Quickview_Image Swipe_[Image Position]_[Product id]_[Color]
                            gtag('event', `Cart_You May Also Like_${window.algoliaModelProper}_Quickview_Image Swipe_${newIndex + 1}_${sku}_${color}`);
                          }
                        } else {
                          if(window.location.href.indexOf('/products/') > -1) {
                            var type = $('#producttype').val();
                            gtag('event', `PDP_Recently Viewed_Quickview_Image Swipe_${newIndex + 1}_${type}_${sku}_${color}`);
                          } else {
                            gtag('event', `Cart_Quickview_Image Swipe_${newIndex + 1}_${sku}`);
                          }
                        }

                      }
                    }
                  }
                });
              }
              if($('.recently-viewed-carousel .swiper-slide').length > 1) {
                if($('.recently-viewed-carousel').length) {
                  var upsellCarousel = new Swiper('.recently-viewed-carousel', {
                    spaceBetween: 7,
                    slidesPerView: 'auto',
                    breakpoints: {
                      1025: {
                        spaceBetween: 14,
                      }
                    },
                    on: {
                      touchStart: function () {
                        // var newIndex = this.activeIndex;
                        // if (typeof gtag === 'function') {
                        //   var sku = $('.cart-upsell-collapse').data('productid');

                        //     if(window.location.href.indexOf('/products/') > -1) {
                        //       var type = $('#producttype').val();
                        //       gtag('event', `PDP_Recently Viewed_Drag_${type}`);
                        //     } else {
                        //       // gtag('event', `Cart_Quickview_Image Swipe_${newIndex + 1}_${sku}`);
                        //     }


                        // }
                      },
                      touchEnd: function() {
                        if (typeof gtag === 'function') {
                          var sku = $('.cart-upsell-collapse').data('productid');

                            if(window.location.href.indexOf('/products/') > -1) {
                              var type = $('#producttype').val();
                              gtag('event', `PDP_Recently Viewed_Drag_${type}`);
                            } else {
                              // gtag('event', `Cart_Quickview_Image Swipe_${newIndex + 1}_${sku}`);
                            }


                        }
                      },
                      touchMove: function() {
                      }
                    }
                  });
                }
              }

                    if($('.swatch-colors').length > 0) {
                      var productCarouselColors = new Swiper('.swatch-colors', {
                        // spaceBetween: 1,
                        slidesPerView: 'auto',
                        navigation: {
                          nextEl: '#swatch-colors-next',
                          prevEl: '#swatch-colors-prev',
                        },
                      });
                    }

              initChainSelects($('.cart-upsell-container'));

              var selectSize = $('.cart-upsell-container .swatch-size .custom-select');
              selectSize.each(function() {
                // if($.length) {
                  var $dropdownParent1 = $(this).closest('.custom-select-wrapper');
                  $(this).select2({
                    placeholder: 'Select Size',
                    minimumResultsForSearch: -1,
                    dropdownParent: $dropdownParent1,
                    dropdownCssClass: "custom-select-dropdown",
                    templateResult: function(data, container) {
                      // if(data.element) {
                      //   $(container).addClass($(data.element).attr('class'));
                      // }

                      var tpl = '<span>'+data.text+'</span>';
                      var notifyMe = $(data.element).hasClass('disabled-el');
                      const delayFlag = $(data.element).data('ship-delay');
                      const shipDelayMessage = $(data.element).data('ship-delay-message');
                      const hasDelayMessage = (delayFlag === true || delayFlag === 'true') && shipDelayMessage;
                      // Tier -> copy via window.ALDLowStock, published by snippets/low-stock-config.liquid
                      // from the same shop metafields the backend reads thresholds from. Guarded so a
                      // missing global degrades to no message rather than breaking the dropdown.
                      const lowStockMessage = (window.ALDLowStock && window.ALDLowStock.messageForTier)
                        ? window.ALDLowStock.messageForTier($(data.element).data('low-stock-tier'))
                        : '';
                      if(notifyMe) {
                        tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">Notify Me</span></span>';
                      } else if(hasDelayMessage) {
                        tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">'+shipDelayMessage+'</span></span>';
                      } else if(lowStockMessage) {
                        tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">'+lowStockMessage+'</span></span>';
                      }
                      return $(tpl);
                    }
                  }).on('select2:select', function(e) {
                    var selectedSize = e.params.data.text;

                    if (typeof gtag === 'function') {
                      var sku = $('.cart-upsell-collapse').data('productid');

                      if($('.cart-upsell-collapse').hasClass('ymal-upsell')) {
                        var prefix = 'US';
                        if(window.location.href.indexOf('eu.') > -1) {
                          prefix = 'EU';
                        }
                        var color = $('.cart-upsell-collapse').data('color');
                        if(window.location.href.indexOf('/products/') > -1) {
                          var type = $('#producttype').val();
                          gtag('event', `PDP_You May Also Like_${window.algoliaModelProper}_Quickview_Select Size:${selectedSize}_${type}_${sku}_${color}`);
                        } else {
                          gtag('event', `Cart_You May Also Like_${window.algoliaModelProper}_Quickview_Select Size:${selectedSize}_${sku}_${color}`);
                        }
                      } else {
                        if(window.location.href.indexOf('/products/') > -1) {
                          var type = $('#producttype').val();

                          var color = $('#upsell-'+sku).parent().data('color');
                          gtag('event', `PDP_Recently Viewed_Quickview_Select Size:${selectedSize}_${type}_${sku}_${color}`);
                        } else {
                          gtag('event', `Cart_Quickview_Select Size_${selectedSize}_${sku}`);
                        }

                      }

                    }
                  });
                // }
              })

              $('.cart-upsell-container').on('click', '.select-options', function() {
                $(this).closest('.upsell-form').find('.chain-selector').show().removeClass('d-none');
                $(this).hide().removeClass('d-block');
                $(this).next().show().removeClass('d-none');
                return false;
              });

        $('.cart-upsell-container').on('change', 'select.chain-select', function() {


          var chainPrice = parseFloat($(this).find(':selected').data('original-price'));
          var pendantPrice = parseFloat($(this).closest('.cart-upsell').find('.product__price').data('price'));


          var totalPendantPrice = chainPrice + pendantPrice;
          // TODO should be local_price
          totalPendantPrice = formatPrice(totalPendantPrice, globalCurrency)
         $(this).closest('.cart-upsell').find('.product__price').text(totalPendantPrice);

         chainId =  $(this).find(':selected').data('prodid');

        });

              $('.swatch-size select, .swatch-size-2 select').on('change', function() {
                $('.select-error').removeClass('select-error');
                $('.size-error').hide();
                $('#show-bis').hide();
                if($(this).find(':selected').hasClass('disabled-el')) {
                  $('.btn-upsell-add').hide();
                  $('.notify').show();
                  BISHandler();
                } else {
                  $('.btn-upsell-add').show();
                  $('.notify').hide();
                }

                var variantName = $(this).find(':selected').val();
                // START: scroll to selected variant image
                // var isMobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)').matches;
                // var imageToScroll = undefined;
                // var imageIndexToScroll = undefined;
                // $('.product__container .product__image-item img').each((index,element) => {
                //   if(variantName.includes(element.alt)) {
                //     imageToScroll = element;
                //     imageIndexToScroll = index;
                //   }
                // });

                // if(imageToScroll) {
                //   if(isMobile) {
                //     if(imageIndexToScroll > -1 && productCarousel) {
                //       productCarousel?.forEach((_c) => {
                //         if(_c.size) _c.slideTo(imageIndexToScroll);
                //       });
                //     }
                //   } else {
                //     $('html, body').animate({ scrollTop: imageToScroll.getBoundingClientRect().top + document.documentElement.scrollTop - 80}, 1000);
                //   }
                // }
                // END: scroll to selected variant image

                // if(!$(this).find(':selected').data('soldout')) {
                //   console.log('1.2')
                //   $('.product__price.money').text('SOLD OUT');

                //   console.log('>>> ', $(this).find(':selected').data('price'), $('#pendant-price').data('price'));
                //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
                //     var pendantPr = parseFloat($('#pendant-price').data('price'));
                //     $('.product__price.money').text(chainPr + pendantPr);
                //   } else {
                //     var priceDetails = {
                //       "Price": parseFloat($(this).find(':selected').data('price')),
                //       "Quantity": 1
                //     };

                //     var curEl = $(this);
                //   }
                // } else {
                //   console.log('1.3')
                //   //$('.product__price.money').text($(this).find(':selected').data('price'))
                //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
                //     var pendantPr = parseFloat($('#pendant-price').data('price'));
                //     $('.product__price.money').text(chainPr + pendantPr);
                //   } else {
                //     var priceDetails = {
                //       "Price": $(this).find(':selected').data('price'),
                //       "Quantity": 1
                //     };

                //     var curEl = $(this);
                //   }
                // }
              });

              // copied from other scripts, to be removed
       // $('.product__variants--colors .custom-select').select2({
       //    placeholder: 'Select Color',
       //    minimumResultsForSearch: -1,
       //    dropdownCssClass: "custom-select-dropdown",
       //    templateResult: function(data, container) {
       //      var img = $(data.element).attr('data-img');
       //      var handle = $(data.element).attr('data-handle');
       //      var tpl = '<a href="'+handle+'"><img src="'+img+'" />'+data.text+'</a>';
       //      return $(tpl);
       //    }
       //  });

              var selectColor = $('.cart-upsell-container .product__variants--colors .custom-select');

              selectColor.each(function() {
                // if(selectColor.length) {
                  var $dropdownParent2 = $(this).closest('.custom-select-wrapper');
                  $(this).select2({
                    placeholder: 'Select Color',
                    minimumResultsForSearch: -1,
                    dropdownParent: $dropdownParent2,
                    dropdownCssClass: "custom-select-dropdown",
                    templateResult: function(data, container) {
                      var img = $(data.element).attr('data-img');
                      var handle = $(data.element).attr('data-handle');
                      var tpl = '<span><img src="'+img+'" />'+data.text+'</span>';
                      return $(tpl);
                    },
                    templateSelection: function(option) {
                      var swatchid = $(option.element).data('swatchid');
                      var img = $('option[data-swatchid="'+swatchid+'"]').data('img');
                      var handle = $(option.element).attr('data-handle');
                      var tpl = '<span><img src="'+img+'" />'+option.text+'</span>';
                      return $(tpl);
                    }
                  });
                // }
              });

               $('.cart-upsell-container').on('change', '.product__variants--colors select', function() {
                var id = $(this).find(':selected').attr('data-swatchid');
                // console.log('upsell mobile select', id, $(this).find('.swatch-colors a[data-swatch-id='+id+']'))
                $(this).closest('.cart-upsell').find('.swatch-colors a[data-swatchid='+id+']').trigger('click');
               });

               $('.you-may-also-like-products').on('keyup', '.ymal-toggle', function(e) {
                  if(e.key === 'Enter' || e.keyCode === 13) {
                    $(this).trigger('click');
                  }
               });

              $('.you-may-also-like-products').on('click', '.ymal-toggle', function() {
                var target = $(this).attr('id');
                var productId = target.split('-')[1];

                if(target.indexOf('ymal') < 0) {
                  target = 'upsell-'+target;
                }
                target = target.replace('ymal', '')

                if (typeof gtag === 'function') {

                  // if($(this).data('swatchids')) {
                    // changing color
                    var colorName = $(this).data('color'); //$(`.product__variants--colors option[data-swatchid="${$(this).data('swatchid')}"]`).first().text();
                    var orderIndex = $(this).data('scounter');
                    // var productId = $('.cart-upsell-collapse').data('productid');
                    var type = $('#producttype').val();
                    // var algoliaModelProper = algoliaModel == 'bought-together' ? 'Frequently Bought Together' : 'Trending Items';

                    if(window.location.href.indexOf('/products/') > -1) {
                      var type = $('#producttype').val();
                      //gtag('event', `PDP_Recently Viewed_Quickview_${colorName}_${type}_${productId}`);
                      gtag('event', `PDP_You May Also Like_${window.algoliaModelProper}_Quickview_Open_${type}_${orderIndex}_${productId}_${colorName}`);
                    } else {
                      //gtag('event', `Cart_Quickview_${colorName}_${productId}`);
                      gtag('event', `Cart_You May Also Like_${window.algoliaModelProper}_Quickview_Open_${orderIndex}_${productId}_${colorName}`); // last should be color
                    }



                  // } else {
                    // clicking recommendated product
                    // var clickedIndex = $(this).closest('.swiper-wrapper')
                      // .find('.recently-viewed-carousel__item')
                      // .index($(this).parents('.recently-viewed-carousel__item'));
                      // console.log('gaev 1')
                    // gtag('event', `Cart_Product Recommendation_${clickedIndex + 1}_${productId}`);
                  // }
                }

                // console.log('>>> target',  target)

                $('.cart-upsell-collapse').removeClass('cart-upsell-collapse')
                $('#popup-'+target).addClass('cart-upsell-collapse');
                initChainSelects($('#popup-'+target));
                $('.cart-upsell-container').addClass('cart-upsell-container--visible');
                $('.cart-upsell-overlay').addClass('cart-upsell-overlay--visible');
                $('body').addClass('cart-upsell--visible');

    // preload other variants, disable for now
                var swatches = $(this).data('swatchids');
                if(swatches === undefined) {
                  swatches = $(this).closest('.cart-upsell').data('swatchids');
                }


                var dataToSend = {
                  'store_name': store,
                  'product_ids': swatches.split(',').map(Number),
                  'iso_code': Shopify.country,
                  // 'location_ids': [35407921289, 68178706569]
                }

                if(window.location.host.indexOf('eu') > -1) {
                  var locationId = 50003247253;
                  if($('body').attr('data-country') == 'GB') {
                    locationId = 74146152597;
                  }

                  var dataToSend = {
                    'store_name': store,
                    'product_ids': swatches.split(',').map(Number),
                    'iso_code': Shopify.country,
                    'location_ids': [locationId]
                  }
                }

                if(window.location.host.indexOf('eu') > -1) {
                  var locationId = 50003247253;
                  if($('body').attr('data-country') == 'GB') {
                    locationId = 74146152597;
                  }

                  var dataToSend = {
                    'store_name': store,
                    'product_ids': swatches.split(',').map(Number),
                    'iso_code': Shopify.country,
                    'location_ids': [locationId]
                  }
                }

                $.ajax({
                  url: 'https://api.aimeleondore.com/api/product_info',
                  type: 'POST',
                  data: JSON.stringify(dataToSend),
                  accept: 'application/json',
                  cache: false,
                  dataType: 'json',
                  contentType: 'application/json',
                  success: function(response) {
                    for(var i in response) {
                      var img = response[i].image_url;
                      var alt = '';
                      for(var j in response[i].images) {
                        if(response[i].images[j].alt == 'dev-product-image-swatch') {
                          img = response[i].images[j].url;
                          alt = response[i].images[j].alt;
                        }
                      }

                      $('.swatch-colors__item[data-swatchid="'+response[i].product_id+'"] .product-image').append(`<img src="${img}&width=100" x alt="${alt}">`);
                      $('option[data-swatchid="'+response[i].product_id+'"]').data('img', img+'&width=100');

                      var product = response[i];

// TODO: handle one size products

                      // TODO should be local_price
                      var price = formatPrice(response[i].local_price.price, response[i].local_price.currency);
                      // var price = formatPrice(response[i].price, 'USD');

                      var compareAtPrice = price;

                      if(response[i].local_price.compare_at_price !== null) {
                        compareAtPrice = response[i].local_price.compare_at_price;
                      } else {
                        compareAtPrice = 0;
                      }
                      var priceToDisplay = '';
                      var classCompare = '';

                      priceToDisplay += '<span class="money">'+price+'</span>';
                      if(response[i].local_price.price < compareAtPrice && response[i].local_price.compare_at_price != 0) {
                        compareAtPrice = formatPrice(response[i].local_price.compare_at_price, response[i].local_price.currency);
                        priceToDisplay += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                        classCompare = 'plp-product__price--compare';
                      }

                      var images = '';
                      for(var j in response[i].images) {
                        if(j != 0) {
                          if(response[i].images[j].alt != 'dev-product-image-swatch') {
                            images += `<div class="swiper-slide upsell-carousel__item">
                                  <img src="${response[i].images[j].url}&width=600" alt="${response[i].images[j].alt}" />
                                </div>`
                          }
                        }
                      }
                      var sizes = '<select class="custom-select" name="sizes-'+product.product_id+'">';

                      var swatches = '';
                      var swatchesMobile = '<option value="">Select Color</option>';
                      var swatchesIds = '';
                      for(var z in response[i].handles_info) {
                        var swatchData = response[i].handles_info[z];
                        var swatchHandle = Object.keys(swatchData);
                        var swatchId = Object.values(swatchData);
                        swatchesIds += Object.values(swatchData) + ',';

                        var selected = '';
                        var selectedClass = '';
                        if(response[i].product_id == swatchId) {
                          selected = 'selected';
                          selectedClass = 'swatch-colors__item--selected';
                        }

                        swatches += `<a href="/products/${swatchHandle}" class="swiper-slide ${selectedClass} swatch-colors__item " new="" data-swatchid="${swatchId}"  data-swatchids="${swatchesIds}">
                                  <div class="image-square product-image">
                                  </div>
                                </a>`

                        var colors = response[i].handles[0];
                        colors = Object.values(colors);
                        colors = colors[0];

                        if(typeof colors === 'string') {
                          colors = colors.replace(/\([^)]*\)/g, '').split(',').map(function(entry) {
                            return entry.trim();
                          }).filter(function(entry) {
                            return entry !== '';
                          });
                        }

                        colors = colors[z];
                        swatchesMobile += `<option ${selected} data-img="" data-handle="" data-swatchid="${swatchId}">${colors}</option>`
                      }

                      if(response[i].handles_info == null) {
                        swatchesMobile = `<option selected data-img="${response[i].image_url}&width=100" data-handle="" data-swatchid="">${response[i].variants[0].color}</option>`;
                      }

                      // console.log('4')
                      swatchesIds = swatchesIds.slice(0, -1);


                      const shipDelaySku = response[i].metafields?.find(mf => mf.ship_delay_skus)?.ship_delay_skus || '';
                      const shipDelayMessage = response[i].metafields?.find(mf => mf.ship_delay_message)?.ship_delay_message || '';

                      if(response[i].variants.length == 1) {
                        sizes += '<option value=""></option>';
                        const singleHasDelay = shipDelaySku.indexOf(response[i].variants[0].sku) > -1 && !response[i].variants[0].sold_out;
                        const singleDelayAttr = ` data-ship-delay="${singleHasDelay}" data-ship-delay-message="${shipDelayMessage}"` +
                          // Tier number only -- the copy lives in window.ALDLowStock and the unit
                          // count never leaves the backend. '' when the API returns null, or when
                          // an older build of it omits the field entirely.
                          ` data-low-stock-tier="${response[i].variants[0].low_stock_tier ?? ''}"`;
                        if(response[i].variants[0].sold_out) {
                          sizes += `<option class="disabled-el" data-soldout="${response[i].variants[0].sold_out}"${singleDelayAttr} value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                        } else {
                          sizes += `<option data-soldout="${response[i].variants[0].sold_out}" selected${singleDelayAttr} value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                        }
                      } else {
                        for(var k in response[i].variants) {
                          sizes += '<option value=""></option>';
                          const variantHasDelay = shipDelaySku.indexOf(response[i].variants[k].sku) > -1 && !response[i].variants[k].sold_out;
                          const delayAttr = ` data-ship-delay="${variantHasDelay}" data-ship-delay-message="${shipDelayMessage}"` +
                            // Tier number only -- the copy lives in window.ALDLowStock and the unit
                            // count never leaves the backend. '' when the API returns null, or when
                            // an older build of it omits the field entirely.
                            ` data-low-stock-tier="${response[i].variants[k].low_stock_tier ?? ''}"`;
                          if(response[i].variants[k].sold_out) {
                            sizes += `<option class="disabled-el" data-soldout="${response[i].variants[k].sold_out}"${delayAttr} value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                          } else {
                            sizes += `<option data-soldout="${response[i].variants[k].sold_out}"${delayAttr} value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                          }
                        }
                      }
                      sizes += '</select>';

                      // if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                      //   sizes = $('.chain-select')[0].outerHTML;

                      //   swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

                      //   swatchesMobile = $('.pendant-select')[0].innerHTML;
                      // }

                      var sizesMobile = '';
                      var showSelectOptions = 'd-none';
                      var showAddToCart = '';
                      var jewelryClass = '';
                      if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                        jewelryClass = 'chain-selector';
                        showSelectOptions = 'd-block';
                        showAddToCart = 'd-none d-lg-block';
                        sizes = $('.chain-select')[0].outerHTML;
                        // sizes = '<select class="custom-select" disabled><option>One Size</option></select>'

                        swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

                        swatchesMobile = $('.pendant-select')[0].innerHTML;
                      }

                      var colorName = response[i].variants[0].color;
                      var customTag = '';

                      if(response[i].tags.indexOf('PREORDER_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">Reserve</div>';
                      }
                      if(response[i].tags.indexOf('NEW_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">NEW</div>  ';
                      }

                      var productLimited = false;
                      var productQuantityLimitNumber = 0;
                      if(response[i].tags.indexOf('dev-qty-limit') > -1) {
                        productLimited = true;
                        productQuantityLimitNumber = response[i].tags.substring(response[i].tags.indexOf('dev-qty-limit')+14, response[i].tags.indexOf('dev-qty-limit')+15);
                      }

                      if(!$('#popup-upsell-'+product.product_id).length) {

                        var addToBag = 'Add To Bag';
                        if(product.sold_out) {
                          addToBag = 'Notify Me';
                        }

                        var nonUSProduct = '';
                        var nonUSProductTpl = '';
                        if(product.tags.indexOf('dev-non-us-oos') > -1) {
                          if(Shopify.country !== 'US') {
                            nonUSProduct = ' style="display: none !important;"';

                            var customLink = '';
                            var customName = '';
                            for(const i in product.metafields) {
                              if(product.metafields[i]['non_us_oos_label'] !== undefined) {
                                priceToDisplay = product.metafields[i]['non_us_oos_label']
                              }
                              if(product.metafields[i]['non_us_oos_button_link'] !== undefined) {
                                customLink = product.metafields[i]['non_us_oos_button_link']
                              }
                              if(product.metafields[i]['non_us_oos_button_name'] !== undefined) {
                                customName = product.metafields[i]['non_us_oos_button_name']
                              }
                            }

                            nonUSProductTpl = `          <div class="upsell-form">
                              <div class="atc-box">
                                <a href="${customLink}" class="btn btn--dark btn--bag btn-upsell-add btn-upsell-add--stl">${customName}</a>
                                <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn" target="_blank" rel="noopener noreferrer">FULL DETAILS</a>
                              </div>
                            </div>` 
                          }
                        }

                        $('.cart-upsell-container').append(`<div class="cart-upsell" data-productid="${product.product_id}" data-limited="${productLimited}" data-limit-val="${productQuantityLimitNumber}" data-variantid="${product.variants[0].id}" id="popup-upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" data-swatchids="${swatchesIds}">
                          <button class="close-upsell d-none" aria-label="Close product details"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 15L15 1M1 1L15 15" stroke="#181818" stroke-width="2" aria-hidden="true"/>
                          </svg></button>
                          <div class="upsell-carousel">
                            <div class="swiper-wrapper">
                              ${images}
                            </div>
                          </div>

                          <div class="upsell-content product">
                            <h2 class="product__title">${product.title}</h2>
                            <div class="product__price  ${classCompare}" data-price="${response[i].local_price.price}">${priceToDisplay}</div>
                            <div class="product__variants product__variants--colors d-none d-lg-block" ${nonUSProduct}>
                              <div class="product-variants-title d-none d-lg-block">
                                Color: ${colorName}
                              </div>
                              <div class="swatch-colors swiper-container">
                                <div class="swiper-wrapper">
                                  ${swatches}
                                </div>
                              </div>
                              <div id="swatch-colors-next" class="swiper-btn-next"></div>
                              <div id="swatch-colors-prev" class="swiper-btn-prev"></div>
                            </div>

                          <form class="upsell-form" ${nonUSProduct}>
                            <div class="random-div d-flex justify-content-between d-lg-block">
                              <div class="product__variants--colors d-lg-none">
                                <div class="custom-select-wrapper">
                                  <select class="custom-select">
                                    ${swatchesMobile}
                                  </select>
                                </div>
                              </div>

                              <div class="swatch-size swatch-size3 custom-select-wrapper ${showSelectOptions} d-lg-none">
                                <select class="custom-select" disabled>
                                  <option val="">One Size</option>
                                </select>
                              </div>

                              <div class="swatch-size swatch-size4 custom-select-wrapper ${jewelryClass} ${showAddToCart}" id="sizes-${product.product_id}">
                                  ${sizes}
                              </div>
                            </div>
                            <div class="atc-box">
                              <button name="add" id="select-options" type="button" class="select-options btn btn--dark btn--bag ${showSelectOptions} d-lg-none">Select Options</button>
                              <button name="add" id="add-submit" type="submit" class="btn btn--dark btn--bag ${showAddToCart} btn-upsell-add">${addToBag}</button>
                              <div class="notify">
                                  <h4 class="notify__txt">Notify me when this product is in stock </h4>
                                  <div class="form-group" style="margin-bottom: 8px; margin-top: 13px;">
                                    <input type="email" id="notify_email" placeholder="Enter your email" name="EMAIL" class="notifyme-control form-control form-control--border" required>
                                  </div>
                                  <input type="button" id="notify" class="btn btn--dark" value="Submit" />
                                  <p class="notify-success-message btn btn--light" style="display: none;">you're on the list</p>

                                  <div class="bis-newsletter-signup">
                                    <input type="checkbox" checked id="bis-newsletter" name="bis-newsletter" class="bis-custom-checkbox">
                                    <label for="bis-newsletter"><span class="bn-out"><span class="bn-in"></span></span><span class="bn-txt">Sign me up for the mailing list</span></label>
                                    <div class="global-privacy-notice-element-small">By providing your email address, you agree to our <a href="${privacyPolicyFileLink}" target="blank">Privacy Policy</a>.</div>
                                  </div>
                              </div>
                              <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn">FULL DETAILS</a>
                            </div>
                          </form>

                          ${nonUSProductTpl}

                          </div>
                        </div>`);
                      }
                    }

              var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
              // if(isSafari || getOS() == 'Mac OS') {
              if(window.innerWidth > 1024) {
                var height = window.innerHeight;
                var imgHeight = height - 340;
                var width = Math.floor((4 * imgHeight) / 5);
                $('.upsell-carousel, .cart-upsell').width(width);
                if(width > 493) {
                  $('.upsell-carousel img').width('100%');
                } else {
                  $('.upsell-carousel img').width('');
                }
              } else {
                $('.upsell-carousel, .cart-upsell').width('');
              }

                    if($('.upsell-carousel').length) {
                      var upsellCarousel = new Swiper('.upsell-carousel', {
                        spaceBetween: 7,
                        slidesPerView: 'auto',
                        breakpoints: {
                          1025: {
                            slidesPerView: 1,
                            spaceBetween: 0,
                            watchOverflow: true,
                          }
                        }
                      });
                    }

                    if($('.recently-viewed-carousel .swiper-slide').length > 1) {
                      if($('.recently-viewed-carousel').length) {
                        var upsellCarousel = new Swiper('.recently-viewed-carousel', {
                          spaceBetween: 7,
                          slidesPerView: 'auto',
                          breakpoints: {
                            1025: {
                              spaceBetween: 14,
                            }
                          }
                        });
                      }
                    }

                    if($('.swatch-colors').length > 0) {
                      var productCarouselColors = new Swiper('.swatch-colors', {
                        // spaceBetween: 1,
                        slidesPerView: 'auto',
                        navigation: {
                          nextEl: '#swatch-colors-next',
                          prevEl: '#swatch-colors-prev',
                        },
                      });
                    }

                    var selectSize = $('.cart-upsell-container .swatch-size .custom-select');
                    selectSize.each(function() {
                      // if($.length) {
                        var $dropdownParent1 = $(this).closest('.custom-select-wrapper');
                        $(this).select2({
                          placeholder: 'Select Size',
                          minimumResultsForSearch: -1,
                          dropdownParent: $dropdownParent1,
                          dropdownCssClass: "custom-select-dropdown",
                          templateResult: function(data, container) {
                            // if(data.element) {
                            //   $(container).addClass($(data.element).attr('class'));
                            // }

                        var tpl = '<span>'+data.text+'</span>';
                        var notifyMe = $(data.element).hasClass('disabled-el');
                        const delayFlag = $(data.element).data('ship-delay');
                        const shipDelayMessage = $(data.element).data('ship-delay-message');
                        const hasDelayMessage = (delayFlag === true || delayFlag === 'true') && shipDelayMessage;
                        // Tier -> copy via window.ALDLowStock, published by snippets/low-stock-config.liquid
                        // from the same shop metafields the backend reads thresholds from. Guarded so a
                        // missing global degrades to no message rather than breaking the dropdown.
                        const lowStockMessage = (window.ALDLowStock && window.ALDLowStock.messageForTier)
                          ? window.ALDLowStock.messageForTier($(data.element).data('low-stock-tier'))
                          : '';
                        if(notifyMe) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">Notify Me</span></span>';
                        } else if(hasDelayMessage) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">'+shipDelayMessage+'</span></span>';
                        } else if(lowStockMessage) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">'+lowStockMessage+'</span></span>';
                        }
                            return $(tpl);
                          }
                        });
                      // }
                    })

                    initChainSelects($('.cart-upsell-container'));

                    if($('.swatch-colors').length > 0) {
                      var productCarouselColors = new Swiper('.swatch-colors', {
                        // spaceBetween: 1,
                        slidesPerView: 'auto',
                        navigation: {
                          nextEl: '#swatch-colors-next',
                          prevEl: '#swatch-colors-prev',
                        },
                      });
                    }

                    $('.swatch-size select, .swatch-size-2 select').on('change', function() {
                      $('.select-error').removeClass('select-error');
                      $('.size-error').hide();
                      $('#show-bis').hide();
                      if($(this).find(':selected').hasClass('disabled-el')) {
                        $('.btn-upsell-add').hide();
                        $('.notify').show();
                      } else {
                        $('.btn-upsell-add').show();
                        $('.notify').hide();
                      }

                      BISHandler($(this).val());

                      var variantName = $(this).find(':selected').val();
                      // START: scroll to selected variant image
                      // var isMobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)').matches;
                      // var imageToScroll = undefined;
                      // var imageIndexToScroll = undefined;
                      // $('.product__container .product__image-item img').each((index,element) => {
                      //   if(variantName.includes(element.alt)) {
                      //     imageToScroll = element;
                      //     imageIndexToScroll = index;
                      //   }
                      // });

                      // if(imageToScroll) {
                      //   if(isMobile) {
                      //     if(imageIndexToScroll > -1 && productCarousel) {
                      //       productCarousel?.forEach((_c) => {
                      //         if(_c.size) _c.slideTo(imageIndexToScroll);
                      //       });
                      //     }
                      //   } else {
                      //     $('html, body').animate({ scrollTop: imageToScroll.getBoundingClientRect().top + document.documentElement.scrollTop - 80}, 1000);
                      //   }
                      // }
                      // END: scroll to selected variant image

                      // if(!$(this).find(':selected').data('soldout')) {
                      //   console.log('1.2')
                      //   $('.product__price.money').text('SOLD OUT');

                      //   console.log('>>> ', $(this).find(':selected').data('price'), $('#pendant-price').data('price'));
                      //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                      //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
                      //     var pendantPr = parseFloat($('#pendant-price').data('price'));
                      //     $('.product__price.money').text(chainPr + pendantPr);
                      //   } else {
                      //     var priceDetails = {
                      //       "Price": parseFloat($(this).find(':selected').data('price')),
                      //       "Quantity": 1
                      //     };

                      //     var curEl = $(this);
                      //   }
                      // } else {
                      //   console.log('1.3')
                      //   //$('.product__price.money').text($(this).find(':selected').data('price'))
                      //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                      //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
                      //     var pendantPr = parseFloat($('#pendant-price').data('price'));
                      //     $('.product__price.money').text(chainPr + pendantPr);
                      //   } else {
                      //     var priceDetails = {
                      //       "Price": $(this).find(':selected').data('price'),
                      //       "Quantity": 1
                      //     };

                      //     var curEl = $(this);
                      //   }
                      // }
                    });

                    var selectColor = $('.cart-upsell-container .product__variants--colors .custom-select');

                    selectColor.each(function() {
                      // if(selectColor.length) {
                        var $dropdownParent2 = $(this).closest('.custom-select-wrapper');
                        $(this).select2({
                          placeholder: 'Select Color',
                          minimumResultsForSearch: -1,
                          dropdownParent: $dropdownParent2,
                          dropdownCssClass: "custom-select-dropdown",
                          templateResult: function(data, container) {
                            var swatchid = $(data.element).data('swatchid');
                            var img = $('option[data-swatchid="'+swatchid+'"]').data('img');
                            var handle = $(data.element).attr('data-handle');
                            var tpl = '<span><img src="'+img+'" />'+data.text+'</span>';
                            return $(tpl);
                          },
                          templateSelection: function(option) {
                            var swatchid = $(option.element).data('swatchid');
                            var img = $('option[data-swatchid="'+swatchid+'"]').data('img');
                            var handle = $(option.element).attr('data-handle');
                            var tpl = '<span><img src="'+img+'" />'+option.text+'</span>';
                            return $(tpl);
                          }
                        });
                      // }
                    });

                  }
                });

    // preload other variants, disable for now
                return false
              });

              $('.cart-upsell-container').on('click', '.swatch-colors__item', function() {
                var target = $(this).data('swatchid');
                var $upsellModals = $('.cart-upsell-container .cart-upsell');
                $(this).find('.close-upsell').trigger('click');
                // $('#popup-upsell-'+id)

                // var target = $(this).attr('id');

                $upsellModals.addClass('cart-upsell--no-transition');

                $('.cart-upsell-collapse').removeClass('cart-upsell-collapse');
                $('#popup-upsell-'+target).addClass('cart-upsell-collapse');
                var releaseTransitions = function() {
                  $upsellModals.removeClass('cart-upsell--no-transition');
                };
                setTimeout(releaseTransitions, 0);

                // setTimeout(function() {
                    if($('.swatch-colors').length > 0) {
                      var productCarouselColors = new Swiper('.swatch-colors', {
                        // spaceBetween: 1,
                        slidesPerView: 'auto',
                        navigation: {
                          nextEl: '#swatch-colors-next',
                          prevEl: '#swatch-colors-prev',
                        },
                      });
                    }
                // }, 2000)

                return false;
              });

              $('.btn-upsell-add').on('click', function() {
  if (typeof gtag === 'function') {
                if($(this).hasClass('upsell-ymal-add')) {
                  var prefix = 'US';
                  if(window.location.href.indexOf('eu.') > -1) {
                    prefix = 'EU';
                  }
                  var prodid = $(this).closest('.ymal-upsell').data('productid')
                  var color = $(this).closest('.ymal-upsell').data('color');
                  var size = $('[name=sizes-'+prodid+']').find(':selected').text()
                  if(window.location.href.indexOf('/products/') > -1) {
                    var type = $('#producttype').val();
                    gtag('event', `PDP_You May Also Like_${window.algoliaModelProper}_Quickview_Add to Bag_${type}_${prodid}_${color}_${size}`);
                  } else {
                    gtag('event', `Cart_You May Also Like_${window.algoliaModelProper}_Quickview_Add to Bag_${prodid}_${color}_${size}`);
                  }
                } else {
                  var sku = $('.cart-upsell-collapse').data('productid');
                  if (typeof gtag === 'function' && sku) {
                    if(window.location.href.indexOf('/products/') > -1) {
                    var type = $('#producttype').val();
                    var prodid = $(this).closest('.cart-upsell').data('productid')
                    var color = $(this).closest('.cart-upsell').data('color');

                          var color = $('#upsell-'+sku).parent().data('color');
                  var size = $('[name=sizes-'+prodid+']').find(':selected').text()
                      gtag('event', `PDP_Recently Viewed_Quickview_Add to Bag_${type}_${prodid}_${color}_${size}`);
                    } else {
                      gtag('event', `Cart_Quickview_Add to Bag_${sku}`);
                    }
                  }
                }
              }
              });

              $('.upsell-full-details-btn').on('click', function() {
  if (typeof gtag === 'function') {
                if($(this).hasClass('upsell-ymal-btn')) {
                  var prefix = 'US';
                  if(window.location.href.indexOf('eu.') > -1) {
                    prefix = 'EU';
                  }
                  var prodid = $(this).closest('.ymal-upsell').data('productid')
                  var color = $(this).closest('.ymal-upsell').data('color');
                  if(window.location.href.indexOf('/products/') == -1) {
                    gtag('event', `Cart_You May Also Like_${window.algoliaModelProper}_Quickview_Full Details_${prodid}_${color}`);
                  }
                } else {
                  var sku = $('.cart-upsell-collapse').data('productid');
                  if (typeof gtag === 'function' && sku) {
                    if(window.location.href.indexOf('/products/') > -1) {
                    var type = $('#producttype').val();
                    var prodid = $(this).closest('.cart-upsell').data('productid')
                    var color = $(this).closest('.cart-upsell').data('color');
                      gtag('event', `PDP_Recently Viewed_Quickview_Full Details_${type}_${prodid}_${color}`);
                    } else {
                      gtag('event', `Cart_Quickview_Full Details_${sku}`);
                    }
                  }
                }
  }
              });
            }
          });
        } else {
          // $('.section-cart').addClass('no-recently-viewed');
        }



    /// end render




                  // $('.you-may-also-like-products').on('click', 'ymal-togglex', function() {

                  //   return false;
                  // });

                  // if(products.nbHits > 8 && window.location.href.indexOf('/search') == -1) {
                  //   $('.search-advanced__products').append('<a class="btn btn--dark" id="view-more-products" href="/search?aq='+searchTerm+'&type=products">View More</a>');

                  //   // Search_View All_[Search Query]
                  //   $('#view-more-products').on('click', function (e) {
                  //     gtag('event', `Search_View All_${searchTerm}`);
                  //   });
                  // }

                  //$('.search-advanced__summary--products').text('SHOP ('+searchCounter+')');
                  // if(searchResultsModified && window.location.href.indexOf('/search') == -1) {
                  //   $('.search-advanced__summary--products').text('SHOP ('+(products.nbHits-1)+')');
                  // } else {
                  //   $('.search-advanced__summary--products').text('SHOP ('+products.nbHits+')');
                  // }

                  // Search_View All_[Search Query]
                  // $('#view-more-products').on('click', function (e) {
                  //   gtag('event', `Search_View All_${searchTerm}`);
                  // });

                  if (typeof gtag === 'function') {
                    if(window.location.href.indexOf('search') > -1) {
                      // Search Page_Result_[Product id]_[Product color]
                      $('.search-advanced__products .plp-product').on('click', function (e) {
                        gtag('event', `Search Page_Result_${product?.id}_${product?.options?.color}`);
                      });
                    } else {
                      // Search_Result_[Product id]_[Product color]
                      $('.search-advanced__products .plp-product').on('click', function (e) {
                        gtag('event', `Search_Result_${product?.id}_${product?.options?.color}`);
                      });
                    }
                  }


                } else {

                  var algoliaModel = 'trending-items';
                  var requestData = {
                    indexName: prefix + "Prod_products",
                    model: algoliaModel,
                    maxRecommendations: 30,
                    threshold: 0,
                    queryParameters: {
                      filters: filtersQuery
                    }
                  }

                  var data = {
                    requests: [
                      requestData
                    ],
                  }

                  $.ajax({
                    url: 'https://KD8QO388XF-dsn.algolia.net/1/indexes/*/recommendations',
                    type: 'POST',
                    headers: {
                      'x-algolia-application-id': 'KD8QO388XF',
                      'x-algolia-api-key': '276afc6221b469815636351357773c8e'
                    },
                    data: JSON.stringify(data),
                    success: function(response) {

                      var products = response.results[0];

                      var storedProductsArray = [];

                      if(localStorage.getItem('recentlyViewed') === null) {
                        localStorage.setItem('recentlyViewed', '');
                      } else {
                        storedProductsArray = localStorage.getItem('recentlyViewed').split(',');
                      }
                      var cleanProductsArray = [];
                      // clear nbhits from recently viewed
                      for(var i in products.hits) {
                        var duplicate = false
                        for(var j in storedProductsArray) {
                          if(parseInt(products.hits[i].id) == parseInt(storedProductsArray[j])) {
                            duplicate = true;
                          }
                        }
                        if(duplicate == false) {
                          cleanProductsArray.push(products.hits[i])
                        }
                      }

                      if($('form.cart .cart-item').length) {
                        var cartProductIds = [];
                        $('form.cart .cart-item').each(function() {
                          cartProductIds.push($(this).data('productid'));
                        });
                        cleanProductsArray = cleanProductsArray.filter(function(el) {
                          return cartProductIds.indexOf(el.id) < 0;
                        })

                      }

                if(products.nbHits > 0 && cleanProductsArray.length > 0) {
                  var searchCounter = 0;
                  var searchResultsModified = false;

                    // hide the other half of products
                    var searchLimit = 16
                    if($(window).width() <= 1024) {
                      searchLimit = 8
                    }
    var superCounter = 0;

if($(window).width() <= 1024) {
  if(cleanProductsArray.length < 5) {
    $('.see-more-products').remove();
  }
} else {
  if(cleanProductsArray.length < 9) {
    $('.see-more-products').remove();
  }
}

                  for(var i in cleanProductsArray) {
                    superCounter++;
                    var product = cleanProductsArray[i];
                    var productPrice = product.price;
                    var price = product.price;
                    var additionalData = '';
                    var secondaryImage = '';
                    var finalprice = '';
                    var warehouseAvail = '';
                    var priceToDisplay = '';
                    var classCompare = '';
                    var finalPrice = '';


                    var productAlt = '';

                    if(product.meta.algoliasearch !== undefined) {
                      if(product.meta.algoliasearch.markets !== undefined) {
                        additionalData = JSON.parse(product.meta.algoliasearch.markets);
                        secondaryImage = additionalData.secondary_image;

                        productAlt = additionalData.images[0].alt;
                        if(location.href.indexOf('eu.') == -1) {
                          warehouseAvail = additionalData.warehouseAvailability.us;
                        } else {
                          if($('body').attr('data-country') == 'GB') {
                            warehouseAvail = additionalData.warehouseAvailability.uk;
                          } else {
                            warehouseAvail = additionalData.warehouseAvailability.eu;
                          }
                        }

                        if(additionalData.marketprices !== undefined) {
                          var currentLocale = Shopify.country;
                          var marketprice = additionalData.marketprices[currentLocale].price;
                          var marketcurrency = additionalData.marketprices[currentLocale].currency;
                          price = formatPrice(marketprice, marketcurrency);

                          var compareAtPrice = price;

                          if(additionalData.marketprices[currentLocale].compare_at_price !== null) {
                            compareAtPrice = additionalData.marketprices[currentLocale].compare_at_price;
                          } else {
                            compareAtPrice = 0;
                          }
                          var priceToDisplay = '';
                          var classCompare = '';

                          finalprice += '<span class="money">'+price+'</span>';
                          if(marketprice < compareAtPrice && compareAtPrice != 0) {
                            compareAtPrice = formatPrice(compareAtPrice, marketcurrency);
                            finalprice += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                            classCompare = 'plp-product__price--compare';
                          }

                        }

                      }
                    }


  if(warehouseAvail == 'available') {

                    if(location.href.indexOf('eu.') != -1) {
                      if(Shopify.country == 'GB' && product.tags.indexOf('dev-algolia-hide-uk') > -1) {
                        searchResultsModified = true;
                        continue;
                      } else if(Shopify.country != 'GB' && product.tags.indexOf('dev-algolia-hide-eu') > -1) {
                        searchResultsModified = true;
                        continue;
                      } else {
                        searchCounter++;
                      }
                    } else {
                      searchCounter++;
                    }

                    finalProducts.push(product.id);

                    if(searchCounter == (searchLimit+1) && window.location.href.indexOf('/search') == -1) {
                      break;
                    } else {
                      finalProductsData.push(product)
                    }

                    var customTag = '';

                    if(secondaryImage === '') {
                      secondaryImage = product.product_image;
                    }


                    if(product.id == 7227129888865) {
                      secondaryImage = 'https://cdn.shopify.com/s/files/1/0302/7829/files/GIFTCARD_7287.jpg?v=1730322305'
                    }


                    if(warehouseAvail != 'available' && product.inventory_policy != 'continue') {
                      finalprice = 'SOLD OUT'
                    }

                    if(warehouseAvail == 'available') {
                      if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">Reserve</div>';
                      }
                      if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
                      }
                      if(product.tags.indexOf('NEW_PRODUCT') > -1 || product.tags.indexOf('new_product') > -1) {
                        customTag = '<div class="plp-product__tag">NEW</div>  ';
                      }
            if(product.tags.indexOf('dev-product-type-women') > -1) {
              customTag = '<div class="plp-product__tag plp-product__tag--nocaps">Women\'s</div>  ';
            }
                    } else {
                      if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
                        finalprice = 'RESERVATIONS FULL';
                      }
                      if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
                        finalprice = 'ENTER THE DRAW';
                      }
                      if(product.tags.indexOf('dev-in-store-only') > -1) {
                        if(product.meta.InStoreLabel !== undefined) {
                          finalprice = product.meta.InStoreLabel.label.replaceAll(' ', '&nbsp;');
                        } else {
                          finalprice = 'IN&nbsp;STORE&nbsp;ONLY';
                        }  
                      }
                      if(product.tags.indexOf('dev-coming-soon') > -1) {
                        finalprice = 'COMING SOON';
                      }
            if(product.tags.indexOf('dev-product-type-women') > -1) {
              customTag = '<div class="plp-product__tag plp-product__tag--nocaps">Women\'s</div>  ';
            }
                    }

                    if(product.id == 6702926626913) {
                      finalprice = '$50 - $1000';
                    }

                    if(product.tags.indexOf('dev-hide-product-price') > -1) {
                      finalprice = '';
                    }

                    var additionalClass = '';
                    if(searchCounter > (searchLimit/2)) {
                      additionalClass = 'ymal-extra ymal-hidden';
                    }

                    $('.you-may-also-like-products').append(`
                      <a tabindex="0" id="upsellymal-${product.id}" data-scounter="${superCounter}" data-color="${product.options.color}" xhref="/products/${product.handle}" class="ymal-toggle plp-product ${additionalClass}">
                        <div class="image-4-5 product-image">
                          ${customTag}
                          <img src="${secondaryImage}&width=600" alt="${productAlt}" />
                        </div>
                        <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">
                          <h3 class="plp-product__title">${product.title}</h3>
                          <div class="plp-product__price ${classCompare}">
                              ${finalprice}
                          </div>
                        </div>
                      </a>
                    `)
  }
                  }

                  // finalProducts.splice(-1);

    /// begin render

                var store = 'aime-leon-dore';
                if(window.location.host.indexOf('eu') > -1) {
                  store = 'aime-leon-dore-eu';
                }
                if(window.location.host.indexOf('dev') > -1) {
                  store = 'aime-leon-dore-dev-store';
                }
                if(window.location.host.indexOf('eu-dev') > -1) {
                  store = 'aime-leon-dore-eu-dev';
                }

          var dataToSend = {
            'store_name': store,
            'product_ids': finalProducts,
            'iso_code': Shopify.country,
            // 'location_id': 68178706569
            // 'location_ids': [35407921289, 68178706569]
          }

          if(window.location.host.indexOf('eu') > -1) {
            var locationId = 50003247253;
            if($('body').attr('data-country') == 'GB') {
              locationId = 74146152597;
            }

            var dataToSend = {
              'store_name': store,
              'product_ids': finalProducts,
              'iso_code': Shopify.country,
              'location_ids': [locationId]
            }
          }

        if(finalProducts.length > 0) {

          $.ajax({
            url: 'https://api.aimeleondore.com/api/product_info',
            type: 'POST',
            data: JSON.stringify(dataToSend),
            accept: 'application/json',
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            success: function(response) {
              var counter = 1;
              for(var i in response) {
                if(response[i].product_id !== undefined) {
                  // if(counter < 9) {
                    if(response[i].sold_out != true && response[i].tags.indexOf('RAFFLE_PRODUCT') < 0 && response[i].tags.indexOf('dev-in-store-only') < 0) {
                      // if(response[i].tags.indexOf('a_ss25_drop1') > -1) {

                      var product = response[i];
                      // TODO should be local_price
                      var price = formatPrice(response[i].local_price.price, response[i].local_price.currency);
                      // var price = formatPrice(response[i].price, 'USD');
                      var compareAtPrice = price;

                      if(response[i].local_price.compare_at_price !== null) {
                        compareAtPrice = response[i].local_price.compare_at_price;
                      } else {
                        compareAtPrice = 0;
                      }
                      var priceToDisplay = '';
                      var classCompare = '';

                      priceToDisplay += '<span class="money">'+price+'</span>';
                      if(response[i].local_price.price < compareAtPrice && response[i].local_price.compare_at_price != 0) {
                        compareAtPrice = formatPrice(response[i].local_price.compare_at_price, response[i].local_price.currency);
                        priceToDisplay += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                        classCompare = 'plp-product__price--compare';
                      }

                      var images = '';
                      for(var j in response[i].images) {
                        if(j != 0) {
                          if(response[i].images[j].alt != 'dev-product-image-swatch') {
                            images += `                    <div class="swiper-slide upsell-carousel__item">
                              <img src="${response[i].images[j].url}&width=600" alt="${response[i].images[j].alt}" />
                            </div>`
                          }
                        }
                      }
                      var sizes = '<select class="custom-select" name="sizes-'+product.product_id+'">';

                      var swatchesMobile = '<option value="">Select Color</option>';
                      var swatches = '';
                      var swatchesIds = '';

                      for(var z in response[i].handles_info) {

                        var swatchData = response[i].handles_info[z];
                        var swatchHandle = Object.keys(swatchData);
                        var swatchId = Object.values(swatchData);
                        swatchesIds += Object.values(swatchData) + ',';

                        if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                          swatchesIds = uniqueJewelrySwatchIds();
                        }

                        var selected = '';
                        var selectedClass = '';
                        if(response[i].product_id == swatchId) {
                          selected = 'selected';
                          selectedClass = 'swatch-colors__item--selected';
                        }

                        swatches += `<a href="/products/${swatchHandle}" class="swiper-slide ${selectedClass} swatch-colors__item upsell-toggle" id="${product.product_id}" new="" data-swatchid="${swatchId}" data-swatchids="${swatchesIds}">
                                  <div class="image-square product-image">
                                  </div>
                                </a>`

                        var colors = response[i].handles[0];
                        colors = Object.values(colors);
                        colors = colors[0];

                        if(typeof colors === 'string') {
                          colors = colors.replace(/\([^)]*\)/g, '').split(',').map(function(entry) {
                            return entry.trim();
                          }).filter(function(entry) {
                            return entry !== '';
                          });
                        }

                        colors = colors[z];
                        swatchesMobile += `<option ${selected} data-img="" data-handle="" data-swatchid="${swatchId}">${colors}</option>`
                      }

                      if(response[i].handles_info == null) {
                        swatchesMobile = `<option selected data-img="${response[i].image_url}&width=100" data-handle="" data-swatchid="">${response[i].variants[0].color}</option>`;
                      }

                      swatchesIds = swatchesIds.slice(0, -1);

    /*
    
    */

                      const shipDelaySku = response[i].metafields?.find(mf => mf.ship_delay_skus)?.ship_delay_skus || '';
                      const shipDelayMessage = response[i].metafields?.find(mf => mf.ship_delay_message)?.ship_delay_message || '';

                      if(response[i].variants.length == 1) {
                        sizes += '<option value=""></option>';
                        const singleHasDelay = shipDelaySku.indexOf(response[i].variants[0].sku) > -1 && !response[i].variants[0].sold_out;
                        const singleDelayAttr = ` data-ship-delay="${singleHasDelay}" data-ship-delay-message="${shipDelayMessage}"` +
                          // Tier number only -- the copy lives in window.ALDLowStock and the unit
                          // count never leaves the backend. '' when the API returns null, or when
                          // an older build of it omits the field entirely.
                          ` data-low-stock-tier="${response[i].variants[0].low_stock_tier ?? ''}"`;
                        if(response[i].variants[0].sold_out) {
                          sizes += `<option class="disabled-el" data-soldout="${response[i].variants[0].sold_out}"${singleDelayAttr} value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                        } else {
                          sizes += `<option data-soldout="${response[i].variants[0].sold_out}" selected${singleDelayAttr} value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                        }
                      } else {
                        for(var k in response[i].variants) {
                          sizes += '<option value=""></option>';
                          const variantHasDelay = shipDelaySku.indexOf(response[i].variants[k].sku) > -1 && !response[i].variants[k].sold_out;
                          const delayAttr = ` data-ship-delay="${variantHasDelay}" data-ship-delay-message="${shipDelayMessage}"` +
                            // Tier number only -- the copy lives in window.ALDLowStock and the unit
                            // count never leaves the backend. '' when the API returns null, or when
                            // an older build of it omits the field entirely.
                            ` data-low-stock-tier="${response[i].variants[k].low_stock_tier ?? ''}"`;
                          if(response[i].variants[k].sold_out) {
                            sizes += `<option class="disabled-el" data-soldout="${response[i].variants[k].sold_out}"${delayAttr} value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                          } else {
                            sizes += `<option data-soldout="${response[i].variants[k].sold_out}"${delayAttr} value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                          }
                        }
                      }

                      sizes += '</select>';

                      var sizesMobile = '';
                      var showSelectOptions = 'd-none';
                      var showAddToCart = '';
                      var jewelryClass = '';
                      if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                        jewelryClass = 'chain-selector';
                        showSelectOptions = 'd-block';
                        showAddToCart = 'd-none d-lg-block';
                        sizes = $('.chain-select')[0].outerHTML;
                        // sizes = '<select class="custom-select" disabled><option>One Size</option></select>'

                        swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

                        swatchesMobile = $('.pendant-select')[0].innerHTML;
                      }

                      var colorName = response[i].variants[0].color;
                      var customTag = '';

                      if(response[i].tags.indexOf('PREORDER_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">Reserve</div>';
                      }
                      if(response[i].tags.indexOf('NEW_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">NEW</div>  ';
                      }

                      var productLimited = false;
                      var productQuantityLimitNumber = 0;
                      if(response[i].tags.indexOf('dev-qty-limit') > -1) {
                        productLimited = true;
                        productQuantityLimitNumber = response[i].tags.substring(response[i].tags.indexOf('dev-qty-limit')+14, response[i].tags.indexOf('dev-qty-limit')+15);
                      }

                      $('.recently-viewed').show();

                      $('#upsellymal-'+product.product_id).attr('data-swatchids', swatchesIds);

                      // $('.recently-viewed-carousel .swiper-wrapper').append(`       <div class="swiper-slide recently-viewed-carousel__item" data-swatchids="${swatchesIds}">
                      //   <a id="upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" class="product-image image-4-5 upsell-toggle">
                      //     ${customTag}
                      //     <img src="${product.images[1].url}&width=600" alt="" />
                      //   </a>
                      //   <div class="short-desc plp-product__details">
                      //     <h3 class="plp-product__title"><a href="#" class="upsell-toggle" id="upsell-${product.product_id}">${product.title}</a></h3>
                      //     <div class="plp-product__price ${classCompare}">
                      //       ${priceToDisplay}
                      //     </div>
                      //   </div>
                      // </div>`);

                      var addToBag = 'Add To Bag';
                      if(product.sold_out) {
                        addToBag = 'Notify Me';
                      }

                      var nonUSProduct = '';
                      var nonUSProductTpl = '';
                      if(product.tags.indexOf('dev-non-us-oos') > -1) {
                        if(Shopify.country !== 'US') {
                          nonUSProduct = ' style="display: none !important;"';

                          var customLink = '';
                          var customName = '';
                          for(const i in product.metafields) {
                            if(product.metafields[i]['non_us_oos_label'] !== undefined) {
                              priceToDisplay = product.metafields[i]['non_us_oos_label']
                            }
                            if(product.metafields[i]['non_us_oos_button_link'] !== undefined) {
                              customLink = product.metafields[i]['non_us_oos_button_link']
                            }
                            if(product.metafields[i]['non_us_oos_button_name'] !== undefined) {
                              customName = product.metafields[i]['non_us_oos_button_name']
                            }
                          }

                          nonUSProductTpl = `          <div class="upsell-form">
                            <div class="atc-box">
                              <a href="${customLink}" class="btn btn--dark btn--bag btn-upsell-add btn-upsell-add--stl">${customName}</a>
                              <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn" target="_blank" rel="noopener noreferrer">FULL DETAILS</a>
                            </div>
                          </div>` 
                        }
                      }

                      $('.cart-upsell-container').append(`<div class="cart-upsell ymal-upsell" data-color="${colorName}" data-productid="${product.product_id}" data-limited="${productLimited}" data-limit-val="${productQuantityLimitNumber}" data-variantid="${product.variants[0].id}" id="popup-upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" data-swatchids="${swatchesIds}">
                        <button class="close-upsell d-none" aria-label="Close product details"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 15L15 1M1 1L15 15" stroke="#181818" stroke-width="2" aria-hidden="true"/>
                        </svg></button>
                        <div class="upsell-carousel">
                          <div class="swiper-wrapper">
                            ${images}
                          </div>
                        </div>

                        <div class="upsell-content product">
                          <h2 class="product__title">${product.title}</h2>
                          <div class="product__price  ${classCompare}" data-price="${response[i].local_price.price}">${priceToDisplay}</div>
                          <div class="product__variants product__variants--colors d-none d-lg-block" ${nonUSProduct}>
                            <div class="product-variants-title d-none d-lg-block">
                              Color: ${colorName}
                            </div>
                            <div class="swatch-colors swiper-container">
                              <div class="swiper-wrapper">
                                ${swatches}
                              </div>
                            </div>
                            <div id="swatch-colors-next" class="swiper-btn-next"></div>
                            <div id="swatch-colors-prev" class="swiper-btn-prev"></div>
                          </div>

                          <form class="upsell-form" ${nonUSProduct}>
                            <div class="random-div d-flex justify-content-between d-lg-block">
                              <div class="product__variants--colors d-lg-none">
                                <div class="custom-select-wrapper">
                                  <select class="custom-select">
                                    ${swatchesMobile}
                                  </select>
                                </div>
                              </div>

                              <div class="swatch-size swatch-size3 custom-select-wrapper ${showSelectOptions} d-lg-none">
                                <select class="custom-select" disabled>
                                  <option val="">One Size</option>
                                </select>
                              </div>

                              <div class="swatch-size swatch-size4 custom-select-wrapper ${jewelryClass} ${showAddToCart}" id="sizes-${product.product_id}">
                                  ${sizes}
                              </div>
                            </div>
                            <div class="atc-box">
                              <button name="add" id="select-options" type="button" class="select-options btn btn--dark btn--bag ${showSelectOptions} d-lg-none">Select Options</button>
                              <button name="add" id="add-submit" type="submit" class="btn btn--dark btn--bag ${showAddToCart} btn-upsell-add upsell-ymal-add btn-upsell-add--ymal">${addToBag}</button>
                              <div class="notify">
                                  <h4 class="notify__txt">Notify me when this product is in stock </h4>
                                  <div class="form-group" style="margin-bottom: 8px; margin-top: 13px;">
                                    <input type="email" id="notify_email" placeholder="Enter your email" name="EMAIL" class="notifyme-control form-control form-control--border" required>
                                  </div>
                                  <input type="button" id="notify" class="btn btn--dark" value="Submit" />
                                  <p class="notify-success-message btn btn--light" style="display: none;">you're on the list</p>

                                  <div class="bis-newsletter-signup">
                                    <input type="checkbox" checked id="bis-newsletter" name="bis-newsletter" class="bis-custom-checkbox">
                                    <label for="bis-newsletter"><span class="bn-out"><span class="bn-in"></span></span><span class="bn-txt">Sign me up for the mailing list</span></label>
                                    <div class="global-privacy-notice-element-small">By providing your email address, you agree to our <a href="${privacyPolicyFileLink}" target="blank">Privacy Policy</a>.</div>
                                  </div>
                              </div>
                              <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn upsell-ymal-btn">FULL DETAILS</a>
                            </div>
                          </form>

                          ${nonUSProductTpl}
                        </div>
                      </div>`);

                      counter++;
                      // }
                    }
                  // }
                }
              }

              if(counter == 1) {
                $('.section-cart').addClass('no-recently-viewed');
              }

              if($('.upsell-carousel').length) {

              var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
              // if(isSafari || getOS() == 'Mac OS') {

              if(window.innerWidth > 1024) {
                var height = window.innerHeight;
                var imgHeight = height - 340;
                var width = Math.floor((4 * imgHeight) / 5);
                $('.upsell-carousel, .cart-upsell').width(width);
                if(width > 493) {
                  $('.upsell-carousel img').width('100%');
                } else {
                  $('.upsell-carousel img').width('');
                }
              } else {
                $('.upsell-carousel, .cart-upsell').width('');
              }

                var upsellCarousel = new Swiper('.upsell-carousel', {
                  spaceBetween: 7,
                  slidesPerView: 'auto',
                  breakpoints: {
                    1025: {
                      slidesPerView: 1,
                      spaceBetween: 0,
                      watchOverflow: true,
                    }
                  },
                  on: {
                    slideChange: function () {
                      var newIndex = this.activeIndex;
                      if (typeof gtag === 'function') {
                        var sku = $('.cart-upsell-collapse').data('productid');
                        if($('.cart-upsell-collapse').hasClass('ymal-upsell')) {
                          var prefix = 'US';
                          if(window.location.href.indexOf('eu.') > -1) {
                            prefix = 'EU';
                          }
                          var color = $('.cart-upsell-collapse').data('color');
                          if(window.location.href.indexOf('/products/') > -1) {
                            var type = $('#producttype').val();
                            gtag('event', `PDP_You May Also Like_${window.algoliaModelProper}_Quickview_Image Swipe_${type}_${newIndex + 1}_${sku}_${color}`);
                          } else {
                            gtag('event', `Cart_You May Also Like_${window.algoliaModelProper}_Quickview_Image Swipe_${newIndex + 1}_${sku}_${color}`);
                          }
                        } else {
                          if(window.location.href.indexOf('/products/') > -1) {
                            var type = $('#producttype').val();
                            gtag('event', `PDP_Recently Viewed_Quickview_Image Swipe_${newIndex + 1}_${type}_${sku}_${color}`);
                          } else {
                            gtag('event', `Cart_Quickview_Image Swipe_${newIndex + 1}_${sku}`);
                          }
                        }

                      }
                    }
                  }
                });
              }
              if($('.recently-viewed-carousel .swiper-slide').length > 1) {
                if($('.recently-viewed-carousel').length) {
                  var upsellCarousel = new Swiper('.recently-viewed-carousel', {
                    spaceBetween: 7,
                    slidesPerView: 'auto',
                    breakpoints: {
                      1025: {
                        spaceBetween: 14,
                      }
                    }
                  });
                }
              }

                    if($('.swatch-colors').length > 0) {
                      var productCarouselColors = new Swiper('.swatch-colors', {
                        // spaceBetween: 1,
                        slidesPerView: 'auto',
                        navigation: {
                          nextEl: '#swatch-colors-next',
                          prevEl: '#swatch-colors-prev',
                        },
                      });
                    }

              initChainSelects($('.cart-upsell-container'));

              var selectSize = $('.cart-upsell-container .swatch-size .custom-select');

              selectSize.each(function() {
                // if($.length) {
                  var $dropdownParent1 = $(this).closest('.custom-select-wrapper');
                  $(this).select2({
                    placeholder: 'Select Size',
                    minimumResultsForSearch: -1,
                    dropdownParent: $dropdownParent1,
                    dropdownCssClass: "custom-select-dropdown",
                    templateResult: function(data, container) {
                      // if(data.element) {
                      //   $(container).addClass($(data.element).attr('class'));
                      // }

                        var tpl = '<span>'+data.text+'</span>';
                        var notifyMe = $(data.element).hasClass('disabled-el');
                        const delayFlag = $(data.element).data('ship-delay');
                        const shipDelayMessage = $(data.element).data('ship-delay-message');
                        const hasDelayMessage = (delayFlag === true || delayFlag === 'true') && shipDelayMessage;
                        // Tier -> copy via window.ALDLowStock, published by snippets/low-stock-config.liquid
                        // from the same shop metafields the backend reads thresholds from. Guarded so a
                        // missing global degrades to no message rather than breaking the dropdown.
                        const lowStockMessage = (window.ALDLowStock && window.ALDLowStock.messageForTier)
                          ? window.ALDLowStock.messageForTier($(data.element).data('low-stock-tier'))
                          : '';
                        if(notifyMe) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">Notify Me</span></span>';
                        } else if(hasDelayMessage) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">'+shipDelayMessage+'</span></span>';
                        } else if(lowStockMessage) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">'+lowStockMessage+'</span></span>';
                        }
                      return $(tpl);
                    }
                  }).on('select2:select', function(e) {
                    var selectedSize = e.params.data.text;

                    if (typeof gtag === 'function') {
                      var sku = $('.cart-upsell-collapse').data('productid');

                      if($('.cart-upsell-collapse').hasClass('ymal-upsell')) {
                        var prefix = 'US';
                        if(window.location.href.indexOf('eu.') > -1) {
                          prefix = 'EU';
                        }
                        var color = $('.cart-upsell-collapse').data('color');
                        if(window.location.href.indexOf('/products/') > -1) {
                          var type = $('#producttype').val();
                          gtag('event', `PDP_You May Also Like_${window.algoliaModelProper}_Quickview_Select Size:${selectedSize}_${type}_${sku}_${color}`);
                        } else {
                          gtag('event', `Cart_You May Also Like_${window.algoliaModelProper}_Quickview_Select Size:${selectedSize}_${sku}_${color}`);
                        }
                      } else {
                        if(window.location.href.indexOf('/products/') > -1) {
                          var type = $('#producttype').val();
                          var color = $('#upsell-'+sku).parent().data('color');
                          gtag('event', `PDP_Recently Viewed_Quickview_Select Size:${selectedSize}_${type}_${sku}_${color}`);
                        } else {
                          gtag('event', `Cart_Quickview_Select Size_${selectedSize}_${sku}`);
                        }

                      }

                    }
                  });
                // }
              })

              $('.cart-upsell-container').on('click', '.select-options', function() {
                $(this).closest('.upsell-form').find('.chain-selector').show().removeClass('d-none');
                $(this).hide().removeClass('d-block');
                $(this).next().show().removeClass('d-none');
                return false;
              });

        $('.cart-upsell-container').on('change', 'select.chain-select', function() {


          var chainPrice = parseFloat($(this).find(':selected').data('original-price'));
          var pendantPrice = parseFloat($(this).closest('.cart-upsell').find('.product__price').data('price'));


          var totalPendantPrice = chainPrice + pendantPrice;
          // TODO should be local_price
          totalPendantPrice = formatPrice(totalPendantPrice, globalCurrency)
         $(this).closest('.cart-upsell').find('.product__price').text(totalPendantPrice);

         chainId =  $(this).find(':selected').data('prodid');

        });

              $('.swatch-size select, .swatch-size-2 select').on('change', function() {
                $('.select-error').removeClass('select-error');
                $('.size-error').hide();
                $('#show-bis').hide();
                if($(this).find(':selected').hasClass('disabled-el')) {
                  $('.btn-upsell-add').hide();
                  $('.notify').show();
                  BISHandler();
                } else {
                  $('.btn-upsell-add').show();
                  $('.notify').hide();
                }

                var variantName = $(this).find(':selected').val();
                // START: scroll to selected variant image
                // var isMobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)').matches;
                // var imageToScroll = undefined;
                // var imageIndexToScroll = undefined;
                // $('.product__container .product__image-item img').each((index,element) => {
                //   if(variantName.includes(element.alt)) {
                //     imageToScroll = element;
                //     imageIndexToScroll = index;
                //   }
                // });

                // if(imageToScroll) {
                //   if(isMobile) {
                //     if(imageIndexToScroll > -1 && productCarousel) {
                //       productCarousel?.forEach((_c) => {
                //         if(_c.size) _c.slideTo(imageIndexToScroll);
                //       });
                //     }
                //   } else {
                //     $('html, body').animate({ scrollTop: imageToScroll.getBoundingClientRect().top + document.documentElement.scrollTop - 80}, 1000);
                //   }
                // }
                // END: scroll to selected variant image

                // if(!$(this).find(':selected').data('soldout')) {
                //   console.log('1.2')
                //   $('.product__price.money').text('SOLD OUT');

                //   console.log('>>> ', $(this).find(':selected').data('price'), $('#pendant-price').data('price'));
                //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
                //     var pendantPr = parseFloat($('#pendant-price').data('price'));
                //     $('.product__price.money').text(chainPr + pendantPr);
                //   } else {
                //     var priceDetails = {
                //       "Price": parseFloat($(this).find(':selected').data('price')),
                //       "Quantity": 1
                //     };

                //     var curEl = $(this);
                //   }
                // } else {
                //   console.log('1.3')
                //   //$('.product__price.money').text($(this).find(':selected').data('price'))
                //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
                //     var pendantPr = parseFloat($('#pendant-price').data('price'));
                //     $('.product__price.money').text(chainPr + pendantPr);
                //   } else {
                //     var priceDetails = {
                //       "Price": $(this).find(':selected').data('price'),
                //       "Quantity": 1
                //     };

                //     var curEl = $(this);
                //   }
                // }
              });

              // copied from other scripts, to be removed
       // $('.product__variants--colors .custom-select').select2({
       //    placeholder: 'Select Color',
       //    minimumResultsForSearch: -1,
       //    dropdownCssClass: "custom-select-dropdown",
       //    templateResult: function(data, container) {
       //      var img = $(data.element).attr('data-img');
       //      var handle = $(data.element).attr('data-handle');
       //      var tpl = '<a href="'+handle+'"><img src="'+img+'" />'+data.text+'</a>';
       //      return $(tpl);
       //    }
       //  });

              var selectColor = $('.cart-upsell-container .product__variants--colors .custom-select');

              selectColor.each(function() {
                // if(selectColor.length) {
                  var $dropdownParent2 = $(this).closest('.custom-select-wrapper');
                  $(this).select2({
                    placeholder: 'Select Color',
                    minimumResultsForSearch: -1,
                    dropdownParent: $dropdownParent2,
                    dropdownCssClass: "custom-select-dropdown",
                    templateResult: function(data, container) {
                      var img = $(data.element).attr('data-img');
                      var handle = $(data.element).attr('data-handle');
                      var tpl = '<span><img src="'+img+'" />'+data.text+'</span>';
                      return $(tpl);
                    },
                    templateSelection: function(option) {
                      var swatchid = $(option.element).data('swatchid');
                      var img = $('option[data-swatchid="'+swatchid+'"]').data('img');
                      var handle = $(option.element).attr('data-handle');
                      var tpl = '<span><img src="'+img+'" />'+option.text+'</span>';
                      return $(tpl);
                    }
                  });
                // }
              });

               $('.cart-upsell-container').on('change', '.product__variants--colors select', function() {
                var id = $(this).find(':selected').attr('data-swatchid');
                $(this).closest('.cart-upsell').find('.swatch-colors a[data-swatchid='+id+']').trigger('click');
               });

               $('.you-may-also-like-products').on('keyup', '.ymal-toggle', function(e) {
                  if(e.key === 'Enter' || e.keyCode === 13) {
                    $(this).trigger('click');
                  }
               });

              $('.you-may-also-like-products').on('click', '.ymal-toggle', function() {
                var target = $(this).attr('id');
                var productId = target.split('-')[1];

                if(target.indexOf('ymal') < 0) {
                  target = 'upsell-'+target;
                }
                target = target.replace('ymal', '')

                if (typeof gtag === 'function') {
                  if($(this).data('swatchid')) {
                    // changing color
                    var colorName = $(`.product__variants--colors option[data-swatchid="${$(this).data('swatchid')}"]`).first().text();
                    var productId = $('.cart-upsell-collapse').data('productid');

                    if(window.location.href.indexOf('/products/') > -1) {
                      var type = $('#producttype').val();
                      gtag('event', `PDP_Recently Viewed_Quickview_${colorName}_${type}_${productId}`);
                    } else {
                      gtag('event', `Cart_Quickview_${colorName}_${productId}`);
                    }



                  } else {
                    // clicking recommendated product
                    var clickedIndex = $(this).closest('.swiper-wrapper')
                      .find('.recently-viewed-carousel__item')
                      .index($(this).parents('.recently-viewed-carousel__item'));
                    // gtag('event', `Cart_Product Recommendation_${clickedIndex + 1}_${productId}`);
                  }
                }

                // console.log('>>> target',  target)
                $('.cart-upsell-collapse').removeClass('cart-upsell-collapse')
                $('#popup-'+target).addClass('cart-upsell-collapse');
                initChainSelects($('#popup-'+target));
                $('.cart-upsell-container').addClass('cart-upsell-container--visible');
                $('.cart-upsell-overlay').addClass('cart-upsell-overlay--visible');
                $('body').addClass('cart-upsell--visible');

    // preload other variants, disable for now
                var swatches = $(this).data('swatchids');
                if(swatches === undefined) {
                  swatches = $(this).closest('.cart-upsell').data('swatchids');
                }


                var dataToSend = {
                  'store_name': store,
                  'product_ids': swatches.split(',').map(Number),
                  'iso_code': Shopify.country,
                  // 'location_ids': [35407921289, 68178706569]
                }

                if(window.location.host.indexOf('eu') > -1) {
                  var locationId = 50003247253;
                  if($('body').attr('data-country') == 'GB') {
                    locationId = 74146152597;
                  }

                  var dataToSend = {
                    'store_name': store,
                    'product_ids': swatches.split(',').map(Number),
                    'iso_code': Shopify.country,
                    'location_ids': [locationId]
                  }
                }

                $.ajax({
                  url: 'https://api.aimeleondore.com/api/product_info',
                  type: 'POST',
                  data: JSON.stringify(dataToSend),
                  accept: 'application/json',
                  cache: false,
                  dataType: 'json',
                  contentType: 'application/json',
                  success: function(response) {
                    for(var i in response) {
                      var img = response[i].image_url;
                      var alt = '';
                      for(var j in response[i].images) {
                        if(response[i].images[j].alt == 'dev-product-image-swatch') {
                          img = response[i].images[j].url;
                          alt = response[i].images[j].alt;
                        }
                      }

                      $('.swatch-colors__item[data-swatchid="'+response[i].product_id+'"] .product-image').append(`<img src="${img}&width=100" y alt="${alt}">`);
                      $('option[data-swatchid="'+response[i].product_id+'"]').data('img', img+'&width=100');

                      var product = response[i];
                      // TODO should be local_price
                      var price = formatPrice(response[i].local_price.price, response[i].local_price.currency);
                      // var price = formatPrice(response[i].price, 'USD');

                      var compareAtPrice = price;

                      if(response[i].local_price.compare_at_price !== null) {
                        compareAtPrice = response[i].local_price.compare_at_price;
                      } else {
                        compareAtPrice = 0;
                      }
                      var priceToDisplay = '';
                      var classCompare = '';

                      priceToDisplay += '<span class="money">'+price+'</span>';
                      if(response[i].local_price.price < compareAtPrice && response[i].local_price.compare_at_price != 0) {
                        compareAtPrice = formatPrice(response[i].local_price.compare_at_price, response[i].local_price.currency);
                        priceToDisplay += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                        classCompare = 'plp-product__price--compare';
                      }

                      var images = '';
                      for(var j in response[i].images) {
                        if(j != 0) {
                          if(response[i].images[j].alt != 'dev-product-image-swatch') {
                            images += `<div class="swiper-slide upsell-carousel__item">
                                  <img src="${response[i].images[j].url}&width=600" alt="${response[i].images[j].alt}" />
                                </div>`
                          }
                        }
                      }
                      var sizes = '<select class="custom-select" name="sizes-'+product.product_id+'">';

                      var swatches = '';
                      var swatchesMobile = '<option value="">Select Color</option>';
                      var swatchesIds = '';
                      for(var z in response[i].handles_info) {
                        var swatchData = response[i].handles_info[z];
                        var swatchHandle = Object.keys(swatchData);
                        var swatchId = Object.values(swatchData);
                        swatchesIds += Object.values(swatchData) + ',';

                        var selected = '';
                        var selectedClass = '';
                        if(response[i].product_id == swatchId) {
                          selected = 'selected';
                          selectedClass = 'swatch-colors__item--selected';
                        }

                        swatches += `<a href="/products/${swatchHandle}" class="swiper-slide ${selectedClass} swatch-colors__item " new="" data-swatchid="${swatchId}"  data-swatchids="${swatchesIds}">
                                  <div class="image-square product-image">
                                  </div>
                                </a>`

                        var colors = response[i].handles[0];
                        colors = Object.values(colors);
                        colors = colors[0];

                        if(typeof colors === 'string') {
                          colors = colors.replace(/\([^)]*\)/g, '').split(',').map(function(entry) {
                            return entry.trim();
                          }).filter(function(entry) {
                            return entry !== '';
                          });
                        }

                        colors = colors[z];
                        swatchesMobile += `<option ${selected} data-img="" data-handle="" data-swatchid="${swatchId}">${colors}</option>`
                      }

                      if(response[i].handles_info == null) {
                        swatchesMobile = `<option selected data-img="${response[i].image_url}&width=100" data-handle="" data-swatchid="">${response[i].variants[0].color}</option>`;
                      }

                      // console.log('4')
                      swatchesIds = swatchesIds.slice(0, -1);


                      if(response[i].variants.length == 1) {
                        sizes += '<option value=""></option>';
                        if(response[i].variants[0].sold_out) {
                          sizes += `<option class="disabled-el" data-soldout="${response[i].variants[0].sold_out}" data-low-stock-tier="${response[i].variants[0].low_stock_tier ?? ''}" value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                        } else {
                          sizes += `<option data-soldout="${response[i].variants[0].sold_out}" selected data-low-stock-tier="${response[i].variants[0].low_stock_tier ?? ''}" value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                        }
                      } else {
                        for(var k in response[i].variants) {
                          sizes += '<option value=""></option>';
                          if(response[i].variants[k].sold_out) {
                            sizes += `<option class="disabled-el" data-soldout="${response[i].variants[k].sold_out}" data-low-stock-tier="${response[i].variants[k].low_stock_tier ?? ''}" value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                          } else {
                            sizes += `<option data-soldout="${response[i].variants[k].sold_out}" data-low-stock-tier="${response[i].variants[k].low_stock_tier ?? ''}" value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                          }
                        }
                      }
                      sizes += '</select>';

                      // if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                      //   sizes = $('.chain-select')[0].outerHTML;

                      //   swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

                      //   swatchesMobile = $('.pendant-select')[0].innerHTML;
                      // }

                      var sizesMobile = '';
                      var showSelectOptions = 'd-none';
                      var showAddToCart = '';
                      var jewelryClass = '';
                      if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                        jewelryClass = 'chain-selector';
                        showSelectOptions = 'd-block';
                        showAddToCart = 'd-none d-lg-block';
                        sizes = $('.chain-select')[0].outerHTML;
                        // sizes = '<select class="custom-select" disabled><option>One Size</option></select>'

                        swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

                        swatchesMobile = $('.pendant-select')[0].innerHTML;
                      }

                      var colorName = response[i].variants[0].color;
                      var customTag = '';

                      if(response[i].tags.indexOf('PREORDER_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">Reserve</div>';
                      }
                      if(response[i].tags.indexOf('NEW_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">NEW</div>  ';
                      }

                      var productLimited = false;
                      var productQuantityLimitNumber = 0;
                      if(response[i].tags.indexOf('dev-qty-limit') > -1) {
                        productLimited = true;
                        productQuantityLimitNumber = response[i].tags.substring(response[i].tags.indexOf('dev-qty-limit')+14, response[i].tags.indexOf('dev-qty-limit')+15);
                      }

                      if(!$('#popup-upsell-'+product.product_id).length) {

                        var addToBag = 'Add To Bag';
                        if(product.sold_out) {
                          addToBag = 'Notify Me';
                        }

                        $('.cart-upsell-container').append(`<div class="cart-upsell" data-productid="${product.product_id}" data-limited="${productLimited}" data-limit-val="${productQuantityLimitNumber}" data-variantid="${product.variants[0].id}" id="popup-upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" data-swatchids="${swatchesIds}">
                          <button class="close-upsell d-none" aria-label="Close product details"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 15L15 1M1 1L15 15" stroke="#181818" stroke-width="2" aria-hidden="true"/>
                          </svg></button>
                          <div class="upsell-carousel">
                            <div class="swiper-wrapper">
                              ${images}
                            </div>
                          </div>

                          <div class="upsell-content product">
                            <h2 class="product__title">${product.title}</h2>
                            <div class="product__price  ${classCompare}" data-price="${response[i].local_price.price}">${priceToDisplay}</div>
                            <div class="product__variants product__variants--colors d-none d-lg-block">
                              <div class="product-variants-title d-none d-lg-block">
                                Color: ${colorName}
                              </div>
                              <div class="swatch-colors swiper-container">
                                <div class="swiper-wrapper">
                                  ${swatches}
                                </div>
                              </div>
                              <div id="swatch-colors-next" class="swiper-btn-next"></div>
                              <div id="swatch-colors-prev" class="swiper-btn-prev"></div>
                            </div>

                          <form class="upsell-form">
                            <div class="random-div d-flex justify-content-between d-lg-block">
                              <div class="product__variants--colors d-lg-none">
                                <div class="custom-select-wrapper">
                                  <select class="custom-select">
                                    ${swatchesMobile}
                                  </select>
                                </div>
                              </div>

                              <div class="swatch-size swatch-size3 custom-select-wrapper ${showSelectOptions} d-lg-none">
                                <select class="custom-select" disabled>
                                  <option val="">One Size</option>
                                </select>
                              </div>

                              <div class="swatch-size swatch-size4 custom-select-wrapper ${jewelryClass} ${showAddToCart}" id="sizes-${product.product_id}">
                                  ${sizes}
                              </div>
                            </div>
                            <div class="atc-box">
                              <button name="add" id="select-options" type="button" class="select-options btn btn--dark btn--bag ${showSelectOptions} d-lg-none">Select Options</button>
                              <button name="add" id="add-submit" type="submit" class="btn btn--dark btn--bag ${showAddToCart} btn-upsell-add">${addToBag}</button>
                              <div class="notify">
                                  <h4 class="notify__txt">Notify me when this product is in stock </h4>
                                  <div class="form-group" style="margin-bottom: 8px; margin-top: 13px;">
                                    <input type="email" id="notify_email" placeholder="Enter your email" name="EMAIL" class="notifyme-control form-control form-control--border" required>
                                  </div>
                                  <input type="button" id="notify" class="btn btn--dark" value="Submit" />
                                  <p class="notify-success-message btn btn--light" style="display: none;">you're on the list</p>

                                  <div class="bis-newsletter-signup">
                                    <input type="checkbox" checked id="bis-newsletter" name="bis-newsletter" class="bis-custom-checkbox">
                                    <label for="bis-newsletter"><span class="bn-out"><span class="bn-in"></span></span><span class="bn-txt">Sign me up for the mailing list</span></label>
                                    <div class="global-privacy-notice-element-small">By providing your email address, you agree to our <a href="${privacyPolicyFileLink}" target="blank">Privacy Policy</a>.</div>
                                  </div>
                              </div>
                              <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn">FULL DETAILS</a>
                            </div>
                          </form>
                          </div>
                        </div>`);
                      }
                    }

              var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
              // if(isSafari || getOS() == 'Mac OS') {
              if(window.innerWidth > 1024) {
                var height = window.innerHeight;
                var imgHeight = height - 340;
                var width = Math.floor((4 * imgHeight) / 5);
                $('.upsell-carousel, .cart-upsell').width(width);
                if(width > 493) {
                  $('.upsell-carousel img').width('100%');
                } else {
                  $('.upsell-carousel img').width('');
                }
              } else {
                $('.upsell-carousel, .cart-upsell').width('');
              }

                    if($('.upsell-carousel').length) {
                      var upsellCarousel = new Swiper('.upsell-carousel', {
                        spaceBetween: 7,
                        slidesPerView: 'auto',
                        breakpoints: {
                          1025: {
                            slidesPerView: 1,
                            spaceBetween: 0,
                            watchOverflow: true,
                          }
                        }
                      });
                    }

                    if($('.recently-viewed-carousel .swiper-slide').length > 1) {
                      if($('.recently-viewed-carousel').length) {
                        var upsellCarousel = new Swiper('.recently-viewed-carousel', {
                          spaceBetween: 7,
                          slidesPerView: 'auto',
                          breakpoints: {
                            1025: {
                              spaceBetween: 14,
                            }
                          }
                        });
                      }
                    }

                    if($('.swatch-colors').length > 0) {
                      var productCarouselColors = new Swiper('.swatch-colors', {
                        // spaceBetween: 1,
                        slidesPerView: 'auto',
                        navigation: {
                          nextEl: '#swatch-colors-next',
                          prevEl: '#swatch-colors-prev',
                        },
                      });
                    }

                    var selectSize = $('.cart-upsell-container .swatch-size .custom-select');
                    selectSize.each(function() {
                      // if($.length) {
                        var $dropdownParent1 = $(this).closest('.custom-select-wrapper');
                        $(this).select2({
                          placeholder: 'Select Size',
                          minimumResultsForSearch: -1,
                          dropdownParent: $dropdownParent1,
                          dropdownCssClass: "custom-select-dropdown",
                          templateResult: function(data, container) {
                            // if(data.element) {
                            //   $(container).addClass($(data.element).attr('class'));
                            // }

                        var tpl = '<span>'+data.text+'</span>';
                        var notifyMe = $(data.element).hasClass('disabled-el');
                        const delayFlag = $(data.element).data('ship-delay');
                        const shipDelayMessage = $(data.element).data('ship-delay-message');
                        const hasDelayMessage = (delayFlag === true || delayFlag === 'true') && shipDelayMessage;
                        // Tier -> copy via window.ALDLowStock, published by snippets/low-stock-config.liquid
                        // from the same shop metafields the backend reads thresholds from. Guarded so a
                        // missing global degrades to no message rather than breaking the dropdown.
                        const lowStockMessage = (window.ALDLowStock && window.ALDLowStock.messageForTier)
                          ? window.ALDLowStock.messageForTier($(data.element).data('low-stock-tier'))
                          : '';
                        if(notifyMe) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">Notify Me</span></span>';
                        } else if(hasDelayMessage) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">'+shipDelayMessage+'</span></span>';
                        } else if(lowStockMessage) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">'+lowStockMessage+'</span></span>';
                        }
                            return $(tpl);
                          }
                        });
                      // }
                    })

                    initChainSelects($('.cart-upsell-container'));

                    if($('.swatch-colors').length > 0) {
                      var productCarouselColors = new Swiper('.swatch-colors', {
                        // spaceBetween: 1,
                        slidesPerView: 'auto',
                        navigation: {
                          nextEl: '#swatch-colors-next',
                          prevEl: '#swatch-colors-prev',
                        },
                      });
                    }

                    $('.swatch-size select, .swatch-size-2 select').on('change', function() {
                      $('.select-error').removeClass('select-error');
                      $('.size-error').hide();
                      $('#show-bis').hide();
                      if($(this).find(':selected').hasClass('disabled-el')) {
                        $('.btn-upsell-add').hide();
                        $('.notify').show();
                      } else {
                        $('.btn-upsell-add').show();
                        $('.notify').hide();
                      }

                      BISHandler($(this).val());

                      var variantName = $(this).find(':selected').val();
                      // START: scroll to selected variant image
                      // var isMobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)').matches;
                      // var imageToScroll = undefined;
                      // var imageIndexToScroll = undefined;
                      // $('.product__container .product__image-item img').each((index,element) => {
                      //   if(variantName.includes(element.alt)) {
                      //     imageToScroll = element;
                      //     imageIndexToScroll = index;
                      //   }
                      // });

                      // if(imageToScroll) {
                      //   if(isMobile) {
                      //     if(imageIndexToScroll > -1 && productCarousel) {
                      //       productCarousel?.forEach((_c) => {
                      //         if(_c.size) _c.slideTo(imageIndexToScroll);
                      //       });
                      //     }
                      //   } else {
                      //     $('html, body').animate({ scrollTop: imageToScroll.getBoundingClientRect().top + document.documentElement.scrollTop - 80}, 1000);
                      //   }
                      // }
                      // END: scroll to selected variant image

                      // if(!$(this).find(':selected').data('soldout')) {
                      //   console.log('1.2')
                      //   $('.product__price.money').text('SOLD OUT');

                      //   console.log('>>> ', $(this).find(':selected').data('price'), $('#pendant-price').data('price'));
                      //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                      //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
                      //     var pendantPr = parseFloat($('#pendant-price').data('price'));
                      //     $('.product__price.money').text(chainPr + pendantPr);
                      //   } else {
                      //     var priceDetails = {
                      //       "Price": parseFloat($(this).find(':selected').data('price')),
                      //       "Quantity": 1
                      //     };

                      //     var curEl = $(this);
                      //   }
                      // } else {
                      //   console.log('1.3')
                      //   //$('.product__price.money').text($(this).find(':selected').data('price'))
                      //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                      //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
                      //     var pendantPr = parseFloat($('#pendant-price').data('price'));
                      //     $('.product__price.money').text(chainPr + pendantPr);
                      //   } else {
                      //     var priceDetails = {
                      //       "Price": $(this).find(':selected').data('price'),
                      //       "Quantity": 1
                      //     };

                      //     var curEl = $(this);
                      //   }
                      // }
                    });

                    var selectColor = $('.cart-upsell-container .product__variants--colors .custom-select');

                    selectColor.each(function() {
                      // if(selectColor.length) {
                        var $dropdownParent2 = $(this).closest('.custom-select-wrapper');
                        $(this).select2({
                          placeholder: 'Select Color',
                          minimumResultsForSearch: -1,
                          dropdownParent: $dropdownParent2,
                          dropdownCssClass: "custom-select-dropdown",
                          templateResult: function(data, container) {
                            var swatchid = $(data.element).data('swatchid');
                            var img = $('option[data-swatchid="'+swatchid+'"]').data('img');
                            var handle = $(data.element).attr('data-handle');
                            var tpl = '<span><img src="'+img+'" />'+data.text+'</span>';
                            return $(tpl);
                          },
                          templateSelection: function(option) {
                            var swatchid = $(option.element).data('swatchid');
                            var img = $('option[data-swatchid="'+swatchid+'"]').data('img');
                            var handle = $(option.element).attr('data-handle');
                            var tpl = '<span><img src="'+img+'" />'+option.text+'</span>';
                            return $(tpl);
                          }
                        });
                      // }
                    });

                  }
                });

    // preload other variants, disable for now
                return false
              });

              $('.cart-upsell-container').on('click', '.swatch-colors__item', function() {
                var target = $(this).data('swatchid');
                var $upsellModals = $('.cart-upsell-container .cart-upsell');
                $(this).find('.close-upsell').trigger('click');
                // $('#popup-upsell-'+id)

                // var target = $(this).attr('id');

                $upsellModals.addClass('cart-upsell--no-transition');
                $('.cart-upsell-collapse').removeClass('cart-upsell-collapse');
                $('#popup-upsell-'+target).addClass('cart-upsell-collapse');
                var releaseTransitions = function() {
                  $upsellModals.removeClass('cart-upsell--no-transition');
                };
                setTimeout(releaseTransitions, 0);

                // setTimeout(function() {
                    if($('.swatch-colors').length > 0) {
                      var productCarouselColors = new Swiper('.swatch-colors', {
                        // spaceBetween: 1,
                        slidesPerView: 'auto',
                        navigation: {
                          nextEl: '#swatch-colors-next',
                          prevEl: '#swatch-colors-prev',
                        },
                      });
                    }
                // }, 2000)

                return false;
              });

              $('.btn-upsell-add').on('click', function() {
  if (typeof gtag === 'function') {
                if($(this).hasClass('upsell-ymal-add')) {
                  var prefix = 'US';
                  if(window.location.href.indexOf('eu.') > -1) {
                    prefix = 'EU';
                  }
                  var prodid = $(this).closest('.ymal-upsell').data('productid')
                  var color = $(this).closest('.ymal-upsell').data('color');
                  var size = $('[name=sizes-'+prodid+']').find(':selected').text()
                  if(window.location.href.indexOf('/products/') > -1) {
                    var type = $('#producttype').val();
                    gtag('event', `PDP_You May Also Like_${window.algoliaModelProper}_Quickview_Add to Bag_${type}_${prodid}_${color}_${size}`);
                  } else {
                    gtag('event', `Cart_You May Also Like_${window.algoliaModelProper}_Quickview_Add to Bag_${prodid}_${color}_${size}`);
                  }
                } else {
                  var sku = $('.cart-upsell-collapse').data('productid');
                  if (typeof gtag === 'function' && sku) {
                    if(window.location.href.indexOf('/products/') > -1) {
                    var type = $('#producttype').val();
                    var prodid = $(this).closest('.cart-upsell').data('productid')
                    var color = $(this).closest('.cart-upsell').data('color');
                  var size = $('[name=sizes-'+prodid+']').find(':selected').text()

                          var color = $('#upsell-'+sku).parent().data('color');
                      gtag('event', `PDP_Recently Viewed_Quickview_Add to Bag_${type}_${prodid}_${color}_${size}`);
                    } else {
                      gtag('event', `Cart_Quickview_Add to Bag_${sku}`);
                    }
                  }
                }
              }
              });

              $('.upsell-full-details-btn').on('click', function() {
  if (typeof gtag === 'function') {
                if($(this).hasClass('upsell-ymal-btn')) {
                  var prefix = 'US';
                  if(window.location.href.indexOf('eu.') > -1) {
                    prefix = 'EU';
                  }
                  var prodid = $(this).closest('.ymal-upsell').data('productid')
                  var color = $(this).closest('.ymal-upsell').data('color');
                  gtag('event', `Cart_You May Also Like_${window.algoliaModelProper}_Quickview_Full Details_${prodid}_${color}`);
                } else {
                  var sku = $('.cart-upsell-collapse').data('productid');
                  if (typeof gtag === 'function' && sku) {
                    if(window.location.href.indexOf('/products/') > -1) {
                    var type = $('#producttype').val();
                    var prodid = $(this).closest('.cart-upsell').data('productid')
                    var color = $(this).closest('.cart-upsell').data('color');
                      gtag('event', `PDP_Recently Viewed_Quickview_Full Details_${type}_${prodid}_${color}`);
                    } else {
                      gtag('event', `Cart_Quickview_Full Details_${sku}`);
                    }
                  }
                }
  }
              });
            }
          });
        } else {
          // $('.section-cart').addClass('no-recently-viewed');
        }



    /// end render




                  // $('.you-may-also-like-products').on('click', 'ymal-togglex', function() {

                  //   return false;
                  // });

                  // if(products.nbHits > 8 && window.location.href.indexOf('/search') == -1) {
                  //   $('.search-advanced__products').append('<a class="btn btn--dark" id="view-more-products" href="/search?aq='+searchTerm+'&type=products">View More</a>');

                  //   // Search_View All_[Search Query]
                  //   $('#view-more-products').on('click', function (e) {
                  //     gtag('event', `Search_View All_${searchTerm}`);
                  //   });
                  // }

                  //$('.search-advanced__summary--products').text('SHOP ('+searchCounter+')');
                  // if(searchResultsModified && window.location.href.indexOf('/search') == -1) {
                  //   $('.search-advanced__summary--products').text('SHOP ('+(products.nbHits-1)+')');
                  // } else {
                  //   $('.search-advanced__summary--products').text('SHOP ('+products.nbHits+')');
                  // }

                  // Search_View All_[Search Query]
                  // $('#view-more-products').on('click', function (e) {
                  //   gtag('event', `Search_View All_${searchTerm}`);
                  // });

                  if (typeof gtag === 'function') {
                    if(window.location.href.indexOf('search') > -1) {
                      // Search Page_Result_[Product id]_[Product color]
                      $('.search-advanced__products .plp-product').on('click', function (e) {
                        gtag('event', `Search Page_Result_${product?.id}_${product?.options?.color}`);
                      });
                    } else {
                      // Search_Result_[Product id]_[Product color]
                      $('.search-advanced__products .plp-product').on('click', function (e) {
                        gtag('event', `Search_Result_${product?.id}_${product?.options?.color}`);
                      });
                    }
                  }

                } else {
                  $('.pdp-recommendations > .you-may-also-like').remove();
                  $('.template-cart .you-may-also-like').remove();
                  $('#CartModalContent .you-may-also-like').remove();

                  setTimeout(function() {
                  $('.pdp-recommendations > .you-may-also-like').remove();
                  $('.template-cart .you-may-also-like').remove();
                  $('#CartModalContent .you-may-also-like').remove();
                  }, 1000)
                  setTimeout(function() {
                  $('.pdp-recommendations > .you-may-also-like').remove();
                  $('.template-cart .you-may-also-like').remove();
                  $('#CartModalContent .you-may-also-like').remove();
                  }, 2000)
                  setTimeout(function() {
                  $('.pdp-recommendations > .you-may-also-like').remove();
                  $('.template-cart .you-may-also-like').remove();
                  $('#CartModalContent .you-may-also-like').remove();
                  }, 4000)

                }
                    }
                  });


                }
              }
            });
          } else {
            $('.you-may-also-like').remove();
          }

        }

    },

    attachEvents: function() {

      // todo: enter key
      // todo: suggestion click
      // todo: view all
      // todo: no results page
      // todo: seconday image

      // todo: you may also like
      // todo: recently viewed

      // todo: price

      // todo: sp: conditional display
      // todo: sp: regular display

      const searchOpen = $('.search-toggle');
      searchOpen.on('click', function() {
        $('header.header').removeClass('header--light').removeClass('header--invert');
        $('.search-advanced').addClass('search-advanced--visible');
        $('.search-advanced__input').focus();

        if(window.location.href.indexOf('/cafe-leon-dore') > -1) {
          $('.header-cafe').hide();
          $('.header-regular').show();
        }

        if (typeof gtag === "function") {
          if(window.location.href.indexOf('search') > -1) {
            gtag('event', 'Search Page_Open');
          } else {
            gtag('event', 'Search_Open');
          }
        }

        if($('.header .nav.nav-collapse').length) {
          $('.close-menu-toggle').trigger('click');
        }

        return false;
      });

      const searchClose = $('.search-advanced__close');
      searchClose.on('click', function() {
        // reset search layer?
        if(window.location.href.indexOf('/cafe-leon-dore') > -1) {
          $('.header-cafe').show();
          $('.header-regular').hide();
        }

        if($('body').hasClass('page-store-new-york') || $('body').hasClass('page-store-london') || $('body').hasClass('page-los-angeles')) {
          $('header').addClass('header--invert').addClass('header--light');
        }

        if(window.location.href.indexOf('search') > -1) {
          if (typeof gtag === "function") {
            gtag('event', `Search Page_Clear Query_${$('.search-advanced__input').val()}`);
          }

          $('.search-advanced__input').val('');
          $('.search-initial').show();
          $('.search-results').hide();
        } else {
          if (typeof gtag === "function") {
            gtag('event', 'Search_Close');
          }
          if($('body').hasClass('template-index')) {
            $('header.header').addClass('header--light');
          }
          $('.search-advanced').removeClass('search-advanced--visible');
        }
      });

      const searchInput = $('.search-advanced__input');
      searchInput.keyup($.debounce(500, aldsearch.searchTermChange))
      searchInput.on('keyup', function(e) {
        showSuggestions = true;
        // if(!(window.location.href.indexOf('search') > -1)) {
          if (e.key === 'Enter' || e.keyCode === 13) {
            if (typeof gtag === 'function') {
              // Search_Enter_[Search Query]
              gtag('event', `Search_Enter_${$(this).val()}`);
            }

            window.location.href = '/search?aq='+$(this).val();
          }
        // } else {
        // }
      })

      const searchProductTab = $('.search-advanced__summary--products');
      searchProductTab.on('click', function() {
        $('.search-advanced__news').hide();
        $('.search-advanced__products-women').hide();
        $('.search-advanced__products').show();
        $('.search-advanced__summary--active').removeClass('search-advanced__summary--active');
        $(this).addClass('search-advanced__summary--active');

        if(window.location.href.indexOf('search') > -1) {
          if (typeof gtag === "function") {
            gtag('event', 'Search Page_Mens Tab');
          }
        } else {
          if (typeof gtag === "function") {
            gtag('event', 'Search_Mens Tab');
          }
        }
      });

      const searchProductWomensTab = $('.search-advanced__summary--products-women');
      searchProductWomensTab.on('click', function() {
        $('.search-advanced__news').hide();
        $('.search-advanced__products').hide();
        $('.search-advanced__products-women').show();
        $('.search-advanced__summary--active').removeClass('search-advanced__summary--active');
        $(this).addClass('search-advanced__summary--active');

        if(window.location.href.indexOf('search') > -1) {
          if (typeof gtag === "function") {
            gtag('event', 'Search Page_Womens Tab');
          }
        } else {
          if (typeof gtag === "function") {
            gtag('event', 'Search_Womens Tab');
          }
        }
      });

      const searchNewsTab = $('.search-advanced__summary--news');
      searchNewsTab.on('click', function() {
        $('.search-advanced__products').hide();
        $('.search-advanced__products-women').hide();
        $('.search-advanced__news').show();
        $('.search-advanced__summary--active').removeClass('search-advanced__summary--active');
        $(this).addClass('search-advanced__summary--active');

        if(window.location.href.indexOf('search') > -1) {
          if (typeof gtag === "function") {
            gtag('event', 'Search Page_News Tab');
          }
        } else {
          if (typeof gtag === "function") {
            gtag('event', 'Search_News Tab');
          }
        }
      });

      $('.search-advanced__products').on('click', '.pagination a', function() {
        const url = new URL(location);
        let page = $(this).data('searchpage');
        if(page !== undefined) {
          url.searchParams.set("page", page);
          history.pushState({}, "", url);
        }

        aldsearch.triggerSearchOnSearchPage();

        return false;
      });

      // , function() {
      //   const searchTerm = $(this).val();
      //   aldsearch.searchTermChange(searchTerm);
      // });

      /* Search */
      // var searchOpen = $('.search-toggle');
      // searchOpen.on('click', function() {
      //    $('.search-desktop').toggleClass('search-collapse');
      //    $('.header').toggleClass('header--search');
      //    $('body').removeClass('menu-collapse').toggleClass('search-visible');
      //    $('.search-desktop .search-field').focus();
      //    /* Main Menu */
      //    $('.nav-collapse').removeClass('nav-collapse');
      //    $('.active-menu-toggle').removeClass('active-menu-toggle');
      //    /* Accessibility Menu */
      //    $('.popup-a--visible').removeClass('popup-a--visible');
      //    return false;
      // });

      // var searchClose = $('.search-close');
      // searchClose.on('click', function() {
      //  $(this).closest('.search-desktop').removeClass('search-collapse');
      //  $('.header').removeClass('header--search');
      //  $('body').removeClass('search-visible');
      //  return false;
      // });

    },

    loadRecentlyViewed: function() {
      var productIds = '';
      var loadRV = false;

      if(localStorage.getItem('recentlyViewed') === null) {
         localStorage.setItem('recentlyViewed', '');
      } else {
        productIds = localStorage.getItem('recentlyViewed').split(',').map(Number);
        loadRV = true;
      }

      if(loadRV) {
        productIds = productIds.filter(function(item, pos, self) {
          return self.indexOf(item) == pos;
        });
  
        var dataToSend = {
          'store_name': store,
          'product_ids': productIds,
          'iso_code': Shopify.country,
          // 'location_id': 68178706569
          // 'location_ids': [35407921289, 68178706569]
        }
  
        if(window.location.host.indexOf('eu') > -1) {
          var locationId = 50003247253;
          if($('body').attr('data-country') == 'GB') {
            locationId = 74146152597;
          }

          var dataToSend = {
            'store_name': store,
            'product_ids': productIds,
            'iso_code': Shopify.country,
            'location_ids': [locationId]
          }
        }
  
        if(productIds.length > 0) {
          $('.search-advanced__recently-viewed--container .swiper-wrapper .swiper-slide').remove();
          $.ajax({
            url: 'https://api.aimeleondore.com/api/product_info',
            type: 'POST',
            data: JSON.stringify(dataToSend),
            accept: 'application/json',
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            success: function(response) {
              var counter = 1;
              for(var i in response) {
                if(response[i].product_id !== undefined) {
                  if(counter < 9) {
                    if(response[i].sold_out != true && response[i].tags.indexOf('RAFFLE_PRODUCT') < 0 && response[i].tags.indexOf('dev-in-store-only') < 0) {
                      // if(response[i].tags.indexOf('a_ss25_drop1') > -1) {
  
                      // console.log(response[i]);
                      var product = response[i];
                      // TODO should n be local_price
                      var price = formatPrice(response[i].local_price.price, response[i].local_price.currency);
                      // var price = formatPrice(response[i].price, 'USD');
                      var compareAtPrice = price;
                      // TODO ADJUST ALG LOC DAT
                      if(response[i].local_price.compare_at_price !== null) {
                        compareAtPrice = response[i].local_price.compare_at_price;
                        // TODO should n be local_price
                        // compareAtPrice = formatPrice(response[i].compare_at_price, 'USD');
                      } else {
                        compareAtPrice = 0;
                      }
                      var priceToDisplay = '';
                      var classCompare = '';

                      priceToDisplay += '<span class="money">'+price+'</span>';
                      if(response[i].local_price.price < compareAtPrice && response[i].local_price.compare_at_price != 0) {
                        compareAtPrice = formatPrice(response[i].local_price.compare_at_price, response[i].local_price.currency);
                        priceToDisplay += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                        classCompare = 'plp-product__price--compare';
                      }

                      var images = '';
                      for(var j in response[i].images) {
                        if(j != 0) {
                          if(response[i].images[j].alt != 'dev-product-image-swatch') {
                            images += `                    <div class="swiper-slide upsell-carousel__item">
                              <img src="${response[i].images[j].url}&width=600" alt="${response[i].images[j].alt}" />
                            </div>`
                          }
                        }
                      }

                      var customTag = '';

                      if(response[i].tags.indexOf('PREORDER_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">Reserve</div>';
                      }
                      if(response[i].tags.indexOf('NEW_PRODUCT') > -1) {
                        customTag = '<div class="plp-product__tag">NEW</div>  ';
                      }
                      if(response[i].tags.indexOf('dev-product-type-women') > -1) {
                        customTag = '<div class="plp-product__tag plp-product__tag--nocaps">Women\'s</div>  ';
                      }

                      $('.search-advanced__you-may-also-like').show();

                      $('.search-advanced__recently-viewed').show();

                  if(product.tags.indexOf('dev-non-us-oos') > -1) {
                    if(Shopify.country !== 'US') {
                      for(const i in product.metafields) {
                        if(product.metafields[i]['non_us_oos_label'] !== undefined) {
                          priceToDisplay = product.metafields[i]['non_us_oos_label']
                        }
                      }
                    }
                  }

                      $('.search-advanced__recently-viewed--container .swiper-wrapper').append(`       <div class="swiper-slide recently-viewed-carousel__item">
                        <a id="upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" data-productid="${product.product_id}" data-color="${product?.variants[0]?.color}" data-position="${counter}" class="product-image image-4-5 upsell-toggle" href="/products/${product.handle}">
                          ${customTag}
                          <img src="${product.images[1].url}&width=600" alt="${product.images[1].alt}" />
                        </a>
                        <div class="short-desc plp-product__details">
                          <h3 class="plp-product__title"><a href="#" class="upsell-toggle" id="upsell-${product.product_id}"  data-productid="${product.product_id}" data-color="${product?.variants[0]?.color}" data-position="${counter}">${product.title}</a></h3>
                          <div class="plp-product__price ${classCompare}">
                            ${priceToDisplay}
                          </div>
                        </div>
                      </div>`);
                    }
                  }

                  $('.search-advanced__recently-viewed').show();
                }
              }

              // Search Page_Recently Viewed__[Position]_[Product id]_[Product color]
              $('.search-advanced__recently-viewed a').on('click', function (e) {
                const productId = $(this).data('productid');
                const color = $(this).data('color');
                const position = $(this).data('position');

                if(window.location.href.indexOf('search') > -1) {
                  if (typeof gtag === 'function') {
                    gtag('event', `Search Page_Recently Viewed_${position}_${productId}_${color}`);
                  }
                } else {
                  if (typeof gtag === 'function') {
                    gtag('event', `Search_Recently Viewed_${position}_${productId}_${color}`);
                  }
                }
              });

              $('.search-advanced__recently-viewed').show();

              if($('.search-advanced__recently-viewed--container .swiper-slide').length > 1) {
                if($('.search-advanced__recently-viewed--container').length) {
                  var upsellCarousel = new Swiper('.search-advanced__recently-viewed--container', {
                    spaceBetween: 7,
                    slidesPerView: 'auto',
                    breakpoints: {
                      1025: {
                        spaceBetween: 14,
                      }
                    }
                  });
                }
              }

              if($('.search-advanced__you-may-also-like--container .swiper-slide').length > 1) {
                if($('.search-advanced__you-may-also-like--container').length) {
                  var upsellCarousel = new Swiper('.search-advanced__you-may-also-like--container', {
                    spaceBetween: 7,
                    slidesPerView: 'auto',
                    breakpoints: {
                      1025: {
                        spaceBetween: 14,
                      }
                    }
                  });
                }
              }
            }
          });
        }
      } else {
        $('.search-advanced__you-may-also-like').show();
        if($('.search-advanced__you-may-also-like--container .swiper-slide').length > 1) {
          if($('.search-advanced__you-may-also-like--container').length) {
            var upsellCarousel = new Swiper('.search-advanced__you-may-also-like--container', {
              spaceBetween: 7,
              slidesPerView: 'auto',
              breakpoints: {
                1025: {
                  spaceBetween: 14,
                }
              }
            });
          }
        }
      }
    },

    searchTermChange: function() {
      const searchTerm = $('.search-advanced__input').val();
        $('.search-results').off('scroll');

      let params = new URLSearchParams(document.location.search);
      let searchPage = params.get('page');

      if(searchPage !== null) {
        searchPage = searchPage - 1;
      } else {
        searchPage = 0;
      }

      if(searchTerm.length == 0) {
        $('.search-initial').show();
        $('.search-results').hide();
      } else {
        $('.search-initial').hide();
        $('.search-results').show();

        $('.search-results > *').hide();
        $('.search-advanced__summary--products, .search-advanced__summary--products-women, .search-advanced__summary--news').text('');

        var prefix = 'US';
        var optFilters = [
                "meta.USMarkets.availability:available<score=10000>"
              ];
        if(window.location.href.indexOf('eu.') > -1) {
          prefix = 'EU';
          optFilters = [
                "meta.EUMarkets.availability:available<score=10000>"
              ];
          if($('body').attr('data-country') == 'GB') {
            optFilters = [
              [
                "meta.UKMarkets.availability:available<score=10000>"
              ]
            ]
          }
        }

        var searchPageResultsToRetrieve = 64;

        var data = {
          requests: [
            {
              params: "hitsPerPage=8&query="+searchTerm,
              indexName: prefix + "Prod_products_query_suggestions",
              type: "default"
            },
            {
              params: "hitsPerPage=16&query="+searchTerm,
              indexName: prefix + "Prod_products",
              type: "default",
              clickAnalytics: true,
              optionalFilters: optFilters,
              facetFilters: ["tags:-dev-product-type-women"]
            },
            {
              params: "hitsPerPage=8&query="+searchTerm,
              indexName: prefix + "Prod_pages",
              type: "default"
            },
            {
              params: "hitsPerPage=10&query="+searchTerm,
              indexName: prefix + "Prod_articles",
              type: "default"
            },
            {
              params: "hitsPerPage=16&query="+searchTerm,
              indexName: prefix + "Prod_products",
              type: "default",
              clickAnalytics: true,
              optionalFilters: optFilters,
              facetFilters: ["tags:dev-product-type-women"]
            },
          ],
          strategy: "none"
        }

        if(window.location.href.indexOf('search') > -1) {
          var data = {
            requests: [
              {
                params: "hitsPerPage=1000&query="+searchTerm,
                indexName: prefix + "Prod_products_query_suggestions",
                type: "default"
              },
              {
                params: "hitsPerPage="+searchPageResultsToRetrieve+"&query="+searchTerm+"&page="+searchPage,
                indexName: prefix + "Prod_products",
                type: "default",
                clickAnalytics: true,
                optionalFilters: optFilters,
                facetFilters: ["tags:-dev-product-type-women"]
              },
              {
                params: "hitsPerPage=1000&query="+searchTerm,
                indexName: prefix + "Prod_pages",
                type: "default"
              },
              {
                params: "hitsPerPage=1000&query="+searchTerm,
                indexName: prefix + "Prod_articles",
                type: "default"
              },
              {
                params: "hitsPerPage="+searchPageResultsToRetrieve+"&query="+searchTerm, //+"&page="+searchPage,
                indexName: prefix + "Prod_products",
                type: "default",
                clickAnalytics: true,
                optionalFilters: optFilters,
                facetFilters: ["tags:dev-product-type-women"]
              }
            ],
            strategy: "none"
          }
        }

        if(prefix == 'US' && Shopify.country != 'US') {
          var data = {
            requests: [
              {
                params: "hitsPerPage=8&query="+searchTerm,
                indexName: prefix + "Prod_products_query_suggestions",
                type: "default"
              },
              {
                params: "hitsPerPage=8&query="+searchTerm,
                indexName: prefix + "Prod_products",
                type: "default",
                filters: 'NOT product_type:"Gift Cards"',
                clickAnalytics: true,
                optionalFilters: optFilters,
                facetFilters: ["tags:-dev-product-type-women"]
              },
              {
                params: "hitsPerPage=8&query="+searchTerm,
                indexName: prefix + "Prod_pages",
                type: "default"
              },
              {
                params: "hitsPerPage=10&query="+searchTerm,
                indexName: prefix + "Prod_articles",
                type: "default"
              },
              {
                params: "hitsPerPage=8&query="+searchTerm,
                indexName: prefix + "Prod_products",
                type: "default",
                filters: 'NOT product_type:"Gift Cards"',
                clickAnalytics: true,
                optionalFilters: optFilters,
                facetFilters: ["tags:dev-product-type-women"]
              }
            ],
            strategy: "none"
          }

          if(window.location.href.indexOf('search') > -1) {
            var data = {
              requests: [
                {
                  params: "hitsPerPage=1000&query="+searchTerm,
                  indexName: prefix + "Prod_products_query_suggestions",
                  type: "default"
                },
                {
                  params: "hitsPerPage="+searchPageResultsToRetrieve+"&query="+searchTerm+"&page="+searchPage,
                  indexName: prefix + "Prod_products",
                  type: "default",
                  filters: 'NOT product_type:"Gift Cards"',
                  clickAnalytics: true,
                  optionalFilters: optFilters,
                  facetFilters: ["tags:-dev-product-type-women"]
                },
                {
                  params: "hitsPerPage=1000&query="+searchTerm,
                  indexName: prefix + "Prod_pages",
                  type: "default"
                },
                {
                  params: "hitsPerPage=1000&query="+searchTerm,
                  indexName: prefix + "Prod_articles",
                  type: "default"
                },
                {
                  params: "hitsPerPage="+searchPageResultsToRetrieve+"&query="+searchTerm, //+"&page="+searchPage,
                  indexName: prefix + "Prod_products",
                  type: "default",
                  filters: 'NOT product_type:"Gift Cards"',
                  clickAnalytics: true,
                  optionalFilters: optFilters,
                  facetFilters: ["tags:dev-product-type-women"]
                }
              ],
              strategy: "none"
            }
          }
        }
var timeoutDelay = 1;
if(window.location.href.indexOf('search') > -1) {
  var timeoutDelay = 1100;
}
setTimeout(function() {
        $.ajax({
          // url: 'https://PKR3QI1SD0.algolia.net/1/indexes/*/queries',
          url: 'https://KD8QO388XF-dsn.algolia.net/1/indexes/*/queries',
          type: 'POST',
          headers: {
            // 'x-algolia-application-id': 'PKR3QI1SD0',
            // 'x-algolia-api-key': '5278ea88cf4f82e904297d1a101ed00f'
            'x-algolia-application-id': 'KD8QO388XF',
            // 'x-algolia-api-key': 'ea5f4aa3de0ddc2548d74408b8fec617'
            'x-algolia-api-key': '276afc6221b469815636351357773c8e'
          },
          data: JSON.stringify(data),
          success: function(response) {

        if(window.location.href.indexOf('search') > -1) {
          if(!searchResultsNumberVisible) {
            $('.search-reults--number').hide()
          }
          searchResultsNumberVisible = false;

          const url = new URL(location);
          url.searchParams.set("aq", searchTerm);
          history.pushState({}, "", url);

          $('.search-results-num').text(response.results[1].nbHits + response.results[2].nbHits + response.results[3].nbHits + response.results[4].nbHits);
          $('.search-results-key').text(searchTerm)
        }

            const suggestions = response.results[0];
            $('.search-advanced__suggestions p').remove();
            if(suggestions.nbHits > 0) {
              if(showSuggestions) {
                $('.search-advanced__suggestions').show();
                for(var i in suggestions.hits) {
                  if(i < 4) {
                    $('.search-advanced__suggestions').append('<p><a href="/search?aq='+encodeURIComponent(suggestions.hits[i].query)+'">'+suggestions.hits[i].query.replace(searchTerm, '<span>'+searchTerm+'</span>')+'</a></p>')
                  }
                }

                if (typeof gtag === 'function') {
                  if(window.location.href.indexOf('search') > -1) {
                    // Search Page_Suggested_[Search Query]
                    $('.search-advanced__suggestions a').on('click', function (e) {
                      const linkName = $(this).text().trim();
                      gtag('event', `Search Page_Suggested_${linkName}`);
                    });
                  } else {
                    // Search_Suggested_[Search Query]
                    $('.search-advanced__suggestions a').on('click', function (e) {
                      const linkName = $(this).text().trim();
                      gtag('event', `Search_Suggested_${linkName}`);
                    });
                  }
                }
              }
            }

            var products = response.results[1];
            var womenProducts = response.results[4];

            // temporary patch
            const insightsProducts = products.hits.slice(0, 20);
            if(insightsProducts.length > 0) {
              aa('viewedObjectIDs', {
                index: prefix + "Prod_products",
                eventName: 'Results Viewed',
                objectIDs: insightsProducts.map(h => h.objectID)
              });
            }


            $('.search-advanced__products .grid-products a, .search-advanced__products .btn').remove();
            $('.search-advanced__products-women .grid-products a, .search-advanced__products-women .btn').remove();

            var mensLabel = "MEN'S";
            var womensLabel = "WOMEN'S";

            var twoTabs = false;
            if(products.nbHits == 0 && womenProducts.nbHits > 0) {
              womensLabel = "WOMEN'S";
            }
            if(products.nbHits > 0 && womenProducts.nbHits == 0) {
              mensLabel = "MEN'S";
            }

            if(products.nbHits > 0) {
              $('.search-advanced__summary').show();
              $('.search-advanced__products').show();
              $('.search-advanced__summary--active').removeClass('search-advanced__summary--active');
              $('.search-advanced__summary--products').addClass('search-advanced__summary--active');

              var searchCounter = 0;
              var searchResultsModified = false;

              for(var i in products.hits) {
                var product = products.hits[i];
                var productPrice = product.price;
                var price = product.price;
                var additionalData = '';
                var secondaryImage = '';
                var finalprice = '';
                var warehouseAvail = '';
                var priceToDisplay = '';
                var classCompare = '';
                var finalPrice = '';

                if(location.href.indexOf('eu.') != -1) {
                  if(Shopify.country == 'GB' && product.tags.indexOf('dev-algolia-hide-uk') > -1) {
                    searchResultsModified = true;
                    continue;
                  } else if(Shopify.country != 'GB' && product.tags.indexOf('dev-algolia-hide-eu') > -1) {
                    searchResultsModified = true;
                    continue;
                  } else {
                    searchCounter++;
                  }
                } else {
                  searchCounter++;
                }

                if(searchCounter == 9 && window.location.href.indexOf('/search') == -1) {
                  break;
                }

                var productAlt = '';

                if(product.meta.algoliasearch !== undefined) {
                  if(product.meta.algoliasearch.markets !== undefined) {
                    additionalData = JSON.parse(product.meta.algoliasearch.markets);
                    secondaryImage = additionalData.secondary_image;
                    // console.log('prod add data:', additionalData);

                    productAlt = additionalData.images[0].alt;

                    if(location.href.indexOf('eu.') == -1) {
                      warehouseAvail = additionalData.warehouseAvailability.us;
                    } else {
                      if($('body').attr('data-country') == 'GB') {
                        warehouseAvail = additionalData.warehouseAvailability.uk;
                      } else {
                        warehouseAvail = additionalData.warehouseAvailability.eu;
                      }
                    }

                    if(additionalData.marketprices !== undefined) {
                      var currentLocale = Shopify.country;
                      var marketprice = additionalData.marketprices[currentLocale].price;
                      var marketcurrency = additionalData.marketprices[currentLocale].currency;
                      price = formatPrice(marketprice, marketcurrency);

                      var compareAtPrice = price;

                      if(additionalData.marketprices[currentLocale].compare_at_price !== null) {
                        compareAtPrice = additionalData.marketprices[currentLocale].compare_at_price;
                      } else {
                        compareAtPrice = 0;
                      }
                      var priceToDisplay = '';
                      var classCompare = '';

                      finalprice += '<span class="money">'+price+'</span>';
                      if(marketprice < compareAtPrice && compareAtPrice != 0) {
                        compareAtPrice = formatPrice(compareAtPrice, marketcurrency);
                        finalprice += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                        classCompare = 'plp-product__price--compare';
                      }

                      // console.log('prod add data price:', additionalData.marketprices[currentLocale].price);
                    }

                  }
                }

                var customTag = '';

                if(secondaryImage === '') {
                  secondaryImage = product.product_image;
                }

                if(warehouseAvail != 'available' && product.inventory_policy != 'continue') {
                  finalprice = 'SOLD OUT'
                }

                if(warehouseAvail == 'available') {
                  if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
                    customTag = '<div class="plp-product__tag">Reserve</div>';
                  }
                  if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
                    customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
                  }
                  if(product.tags.indexOf('NEW_PRODUCT') > -1 || product.tags.indexOf('new_product') > -1) {
                    customTag = '<div class="plp-product__tag">NEW</div>  ';
                  }
                } else {
                  if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
                    finalprice = 'RESERVATIONS FULL';
                  }
                  if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
                    finalprice = 'ENTER THE DRAW';
                  }
                  if(product.tags.indexOf('dev-in-store-only') > -1) {
                    if(product.meta.InStoreLabel !== undefined) {
                      finalprice = product.meta.InStoreLabel.label.replaceAll(' ', '&nbsp;');
                    } else {
                      finalprice = 'IN&nbsp;STORE&nbsp;ONLY';
                    }                    
                  }
                  if(product.tags.indexOf('dev-coming-soon') > -1) {
                    finalprice = 'COMING SOON';
                  }
                }

                customTag = getOverImageBadges(product, searchBadgesExcludedTags);

                if(product.id == 6702926626913) {
                  finalprice = '$50 - $1000';
                }

                if(product.tags.indexOf('dev-hide-product-price') > -1) {
                  finalprice = '';
                }

                if(product.tags.indexOf('dev-non-us-oos') > -1 && Shopify.country !== 'US') {
                  if(product.meta.custom !== undefined) {
                    finalprice = product.meta.custom.non_us_oos_label
                  }
                }


                $('.search-advanced__products .grid-products').append(`
                  <a href="/products/${product.handle}" class="plp-product search-hit" data-objectid="${product.objectID}" data-position="${product.position}" data-queryid="${products.queryID}">
                    <div class="image-4-5 product-image">
                      ${customTag}
                      <img src="${secondaryImage}&width=600" alt="${productAlt}" />
                    </div>
                    <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">
                      <h3 class="plp-product__title">${product.title}</h3>
                      <div class="plp-product__price ${classCompare}">
                          ${finalprice}
                      </div>
                    </div>
                  </a>
                `)
              }
              if(products.nbHits > 8 && window.location.href.indexOf('/search') == -1) {
                $('.search-advanced__products').append('<a class="btn btn--dark" id="view-more-products" href="/search?aq='+searchTerm+'&type=products&division=regular">View More</a>');

                // Search_View All_[Search Query]
                $('#view-more-products').on('click', function (e) {
                  if (typeof gtag === 'function') {
                    gtag('event', `Search_View All_${searchTerm}`);
                  }
                });
              }

              //$('.search-advanced__summary--products').text('SHOP ('+searchCounter+')');
              if(searchResultsModified && window.location.href.indexOf('/search') == -1) {
                $('.search-advanced__summary--products').text(mensLabel + ' ('+(products.nbHits-1)+')');
              } else {
                $('.search-advanced__summary--products').text(mensLabel + ' ('+products.nbHits+')');  
              }

              // Search_View All_[Search Query]
              $('#view-more-products').on('click', function (e) {
                if (typeof gtag === 'function') {
                  gtag('event', `Search_View All_${searchTerm}`);
                }
              });

              if (typeof gtag === 'function') {
                if(window.location.href.indexOf('search') > -1) {
                  // Search Page_Result_[Product id]_[Product color]
                  $('.search-advanced__products .plp-product').on('click', function (e) {
                    if (typeof gtag === 'function') {
                    gtag('event', `Search Page_Result_${product?.id}_${product?.options?.color}`);
                  }
                  });
                } else {
                  // Search_Result_[Product id]_[Product color]
                  $('.search-advanced__products .plp-product').on('click', function (e) {
                    if (typeof gtag === 'function') {
                    gtag('event', `Search_Result_${product?.id}_${product?.options?.color}`);
                  }
                  });
                }
              }
              if(window.location.href.indexOf('/search') > -1) {
                // ga events on load and scroll
                  var isFiltersEnabled = $('.filter-toggle sup').text() != '' ? true : false;
/*
                  var productsShown = 0;
                  var productsAlreadyShown = 0;
                  var visibleRows = 0;

                  var itemsPerRow = 0;
                  var deviceType = $(window).width() < 1025 ? 'm' : 'd';
                  if(deviceType == 'm') {
                    itemsPerRow = 2;
                  } else {
                    itemsPerRow = 4;
                  }

                  var offsetTop = $('.plp-product').first().offset().top;
                  var screenHeight = $(window).height();
                  var scrolledDistance = $(window).scrollTop();
                  var productHeight = $('.plp-product').first().height();
                  var windowHeight = $(window).height();

                  var counter = 0;
                  while(productHeight * counter + offsetTop < scrolledDistance + windowHeight) {
                    counter++;
                  }

                  var productsShown =  itemsPerRow * (counter - 1);
                  
                  var urlParams   = new URLSearchParams(window.location.search);

                  var currentPage = urlParams.get('page');
                  if(currentPage === null) {
                    currentPage = 1;
                  }

                  var currentSearchTerm = urlParams.get('aq');
                  if(currentSearchTerm === null) {
                    currentSearchTerm = '';
                  }

                  if(productsShown > productsAlreadyShown) {
                    if($('.plp-product').length >= productsShown) {
                      if(typeof gtag === 'function') {
                        productsAlreadyShown = productsShown;
                        gtag('event', `pagination_search_${currentSearchTerm}_${deviceType}_${currentPage}_${itemsPerRow}_${productsShown}`); 
                      }
                    }
                  } 

                  $('.search-results').scroll(function() {

                    // console.log('scroll event')

                    // var productsShown = 0;
                    // var productsAlreadyShown = 0;
                    var visibleRows = 0;

                    var itemsPerRow = 0;
                    var deviceType = $(window).width() < 1025 ? 'm' : 'd';
                    if(deviceType == 'm') {
                      itemsPerRow = 2;
                    } else {
                      itemsPerRow = 4;
                    }

                    var offsetTop = $('.plp-product').first().offset().top;
                    var screenHeight = $(window).height();

                    // scrollTop to fix

                    var scrolledDistance = $(window).scrollTop();
                    var productHeight = $('.plp-product').first().height();
                    var windowHeight = $(window).height();

                    var counter = 0;
                    while(productHeight * counter + offsetTop < scrolledDistance + windowHeight) {
                      counter++;
                    }

                    // console.log('search scroll', counter);

                    var productsShown =  itemsPerRow * (counter - 1);
                    
                    var urlParams   = new URLSearchParams(window.location.search);

                    var currentPage = urlParams.get('page');
                    if(currentPage === null) {
                      currentPage = 1;
                    }

                    var currentSearchTerm = urlParams.get('aq');
                    if(currentSearchTerm === null) {
                      currentSearchTerm = '';
                    }

                    if(productsShown > productsAlreadyShown) {

                      if($('.plp-product').length >= productsShown) {

                        if(typeof gtag === 'function') {
                          productsAlreadyShown = productsShown;
                          gtag('event', `pagination_search_${currentSearchTerm}_${deviceType}_${currentPage}_${itemsPerRow}_${productsShown}`); 
                        }
                      }
                    } 

                  });
*/
                    
              }

              // pagination
              if(window.location.href.indexOf('/search') > -1 && products.nbPages > 1) {
                aldsearch.buildPagination(products.nbHits, products.nbPages, products.page);

                // update url to contain page index

                // make sure reloading page takes into account page number
              }
            }

            if(womenProducts.nbHits > 0) {
              
              $('.search-advanced__summary').show();
              if(products.nbHits == 0) {
                $('.search-advanced__products-women').show();
                $('.search-advanced__summary--active').removeClass('search-advanced__summary--active');
                $('.search-advanced__summary--products-women').addClass('search-advanced__summary--active');
              }
              if(window.location.href.indexOf('division=women') > -1) {
                $('.search-advanced__products-women').show();
                $('.search-advanced__summary--active').removeClass('search-advanced__summary--active');
                $('.search-advanced__summary--products-women').addClass('search-advanced__summary--active');
              }

              products = womenProducts;

              var searchCounter = 0;
              var searchResultsModified = false;

              for(var i in products.hits) {
                var product = products.hits[i];
                var productPrice = product.price;
                var price = product.price;
                var additionalData = '';
                var secondaryImage = '';
                var finalprice = '';
                var warehouseAvail = '';
                var priceToDisplay = '';
                var classCompare = '';
                var finalPrice = '';

                if(location.href.indexOf('eu.') != -1) {
                  if(Shopify.country == 'GB' && product.tags.indexOf('dev-algolia-hide-uk') > -1) {
                    searchResultsModified = true;
                    continue;
                  } else if(Shopify.country != 'GB' && product.tags.indexOf('dev-algolia-hide-eu') > -1) {
                    searchResultsModified = true;
                    continue;
                  } else {
                    searchCounter++;
                  }
                } else {
                  searchCounter++;
                }

                if(searchCounter == 9 && window.location.href.indexOf('/search') == -1) {
                  break;
                }

                var productAlt = '';

                if(product.meta.algoliasearch !== undefined) {
                  if(product.meta.algoliasearch.markets !== undefined) {
                    additionalData = JSON.parse(product.meta.algoliasearch.markets);
                    secondaryImage = additionalData.secondary_image;

                    productAlt = additionalData.images[0].alt;
                    // console.log('prod add data:', additionalData);
                    if(location.href.indexOf('eu.') == -1) {
                      warehouseAvail = additionalData.warehouseAvailability.us;
                    } else {
                      if($('body').attr('data-country') == 'GB') {
                        warehouseAvail = additionalData.warehouseAvailability.uk;
                      } else {
                        warehouseAvail = additionalData.warehouseAvailability.eu;
                      }
                    }

                    if(additionalData.marketprices !== undefined) {
                      var currentLocale = Shopify.country;
                      var marketprice = additionalData.marketprices[currentLocale].price;
                      var marketcurrency = additionalData.marketprices[currentLocale].currency;
                      price = formatPrice(marketprice, marketcurrency);

                      var compareAtPrice = price;

                      if(additionalData.marketprices[currentLocale].compare_at_price !== null) {
                        compareAtPrice = additionalData.marketprices[currentLocale].compare_at_price;
                      } else {
                        compareAtPrice = 0;
                      }
                      var priceToDisplay = '';
                      var classCompare = '';

                      finalprice += '<span class="money">'+price+'</span>';
                      if(marketprice < compareAtPrice && compareAtPrice != 0) {
                        compareAtPrice = formatPrice(compareAtPrice, marketcurrency);
                        finalprice += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                        classCompare = 'plp-product__price--compare';
                      }

                      // console.log('prod add data price:', additionalData.marketprices[currentLocale].price);
                    }

                  }
                }

                var customTag = '';

                if(secondaryImage === '') {
                  secondaryImage = product.product_image;
                }

                if(warehouseAvail != 'available' && product.inventory_policy != 'continue') {
                  finalprice = 'SOLD OUT'
                }

                if(warehouseAvail == 'available') {
                  if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
                    customTag = '<div class="plp-product__tag">Reserve</div>';
                  }
                  if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
                    customTag = '<div class="plp-product__tag">ENTER THE DRAW</div>  ';
                  }
                  if(product.tags.indexOf('NEW_PRODUCT') > -1 || product.tags.indexOf('new_product') > -1) {
                    customTag = '<div class="plp-product__tag">NEW</div>  ';
                  }
                } else {
                  if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
                    finalprice = 'RESERVATIONS FULL';
                  }
                  if(product.tags.indexOf('RAFFLE_PRODUCT') > -1) {
                    finalprice = 'ENTER THE DRAW';
                  }
                  if(product.tags.indexOf('dev-in-store-only') > -1) {
                    if(product.meta.InStoreLabel !== undefined) {
                      finalprice = product.meta.InStoreLabel.label.replaceAll(' ', '&nbsp;');
                    } else {
                      finalprice = 'IN&nbsp;STORE&nbsp;ONLY';
                    }                    
                  }
                  if(product.tags.indexOf('dev-coming-soon') > -1) {
                    finalprice = 'COMING SOON';
                  }
                }

                customTag = getOverImageBadges(product, searchBadgesExcludedTags);

                if(product.id == 6702926626913) {
                  finalprice = '$50 - $1000';
                }

                if(product.tags.indexOf('dev-hide-product-price') > -1) {
                  finalprice = '';
                }

                if(product.tags.indexOf('dev-non-us-oos') > -1 && Shopify.country !== 'US') {
                  if(product.meta.custom !== undefined) {
                    finalprice = product.meta.custom.non_us_oos_label
                  }
                }


                $('.search-advanced__products-women .grid-products').append(`
                  <a href="/products/${product.handle}" class="plp-product search-hit" data-objectid="${product.objectID}" data-position="${product.position}" data-queryid="${products.queryID}">
                    <div class="image-4-5 product-image">
                      ${customTag}
                      <img src="${secondaryImage}&width=600" alt="${productAlt}" />
                    </div>
                    <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">
                      <h3 class="plp-product__title">${product.title}</h3>
                      <div class="plp-product__price ${classCompare}">
                          ${finalprice}
                      </div>
                    </div>
                  </a>
                `)
              }
              if(products.nbHits > 8 && window.location.href.indexOf('/search') == -1) {
                $('.search-advanced__products-women').append('<a class="btn btn--dark" id="view-more-products-women" href="/search?aq='+searchTerm+'&type=products&division=women">View More</a>');

                // Search_View All_[Search Query]
                // $('#view-more-products').on('click', function (e) {
                //   if (typeof gtag === 'function') {
                //     gtag('event', `Search_View All_${searchTerm}`);
                //   }
                // });
              }

              //$('.search-advanced__summary--products').text('SHOP ('+searchCounter+')');
              if(searchResultsModified && window.location.href.indexOf('/search') == -1) {
                $('.search-advanced__summary--products-women').text(womensLabel + ' ('+(products.nbHits-1)+')');
              } else {
                $('.search-advanced__summary--products-women').text(womensLabel + ' ('+products.nbHits+')');  
              }

              // Search_View All_[Search Query]
              // $('#view-more-products').on('click', function (e) {
              //   if (typeof gtag === 'function') {
              //     gtag('event', `Search_View All_${searchTerm}`);
              //   }
              // });

              // if (typeof gtag === 'function') {
              //   if(window.location.href.indexOf('search') > -1) {
              //     // Search Page_Result_[Product id]_[Product color]
              //     $('.search-advanced__products .plp-product').on('click', function (e) {
              //       if (typeof gtag === 'function') {
              //       gtag('event', `Search Page_Result_${product?.id}_${product?.options?.color}`);
              //     }
              //     });
              //   } else {
              //     // Search_Result_[Product id]_[Product color]
              //     $('.search-advanced__products .plp-product').on('click', function (e) {
              //       if (typeof gtag === 'function') {
              //       gtag('event', `Search_Result_${product?.id}_${product?.options?.color}`);
              //     }
              //     });
              //   }
              // }
              if(window.location.href.indexOf('/search') > -1) {
                // ga events on load and scroll
                  var isFiltersEnabled = $('.filter-toggle sup').text() != '' ? true : false;

                  /*
                  var productsShown = 0;
                  var productsAlreadyShown = 0;
                  var visibleRows = 0;

                  var itemsPerRow = 0;
                  var deviceType = $(window).width() < 1025 ? 'm' : 'd';
                  if(deviceType == 'm') {
                    itemsPerRow = 2;
                  } else {
                    itemsPerRow = 4;
                  }

                  var offsetTop = $('.plp-product').first().offset().top;
                  var screenHeight = $(window).height();
                  var scrolledDistance = $(window).scrollTop();
                  var productHeight = $('.plp-product').first().height();
                  var windowHeight = $(window).height();

                  var counter = 0;
                  while(productHeight * counter + offsetTop < scrolledDistance + windowHeight) {
                    counter++;
                  }

                  var productsShown =  itemsPerRow * (counter - 1);
                  
                  var urlParams   = new URLSearchParams(window.location.search);

                  var currentPage = urlParams.get('page');
                  if(currentPage === null) {
                    currentPage = 1;
                  }

                  var currentSearchTerm = urlParams.get('aq');
                  if(currentSearchTerm === null) {
                    currentSearchTerm = '';
                  }

                  if(productsShown > productsAlreadyShown) {
                    if($('.plp-product').length >= productsShown) {
                      if(typeof gtag === 'function') {
                        productsAlreadyShown = productsShown;
                        // gtag('event', `pagination_search_${currentSearchTerm}_${deviceType}_${currentPage}_${itemsPerRow}_${productsShown}`); 
                      }
                    }
                  } 
                  */

                  /*
                  $('.search-results').scroll(function() {

                    // console.log('scroll event')

                    // var productsShown = 0;
                    // var productsAlreadyShown = 0;
                    var visibleRows = 0;

                    var itemsPerRow = 0;
                    var deviceType = $(window).width() < 1025 ? 'm' : 'd';
                    if(deviceType == 'm') {
                      itemsPerRow = 2;
                    } else {
                      itemsPerRow = 4;
                    }

                    var offsetTop = $('.plp-product').first().offset().top;
                    var screenHeight = $(window).height();

                    // scrollTop to fix

                    var scrolledDistance = $(window).scrollTop();
                    var productHeight = $('.plp-product').first().height();
                    var windowHeight = $(window).height();

                    var counter = 0;
                    while(productHeight * counter + offsetTop < scrolledDistance + windowHeight) {
                      counter++;
                    }

                    // console.log('search scroll', counter);

                    var productsShown =  itemsPerRow * (counter - 1);
                    
                    var urlParams   = new URLSearchParams(window.location.search);

                    var currentPage = urlParams.get('page');
                    if(currentPage === null) {
                      currentPage = 1;
                    }

                    var currentSearchTerm = urlParams.get('aq');
                    if(currentSearchTerm === null) {
                      currentSearchTerm = '';
                    }

                    if(productsShown > productsAlreadyShown) {

                      if($('.plp-product').length >= productsShown) {

                        if(typeof gtag === 'function') {
                          productsAlreadyShown = productsShown;
                          gtag('event', `pagination_search_${currentSearchTerm}_${deviceType}_${currentPage}_${itemsPerRow}_${productsShown}`); 
                        }
                      }
                    } 

                  });
                  */
                    
              }

              // pagination
              if(window.location.href.indexOf('/search') > -1 && products.nbPages > 1) {
                // aldsearch.buildPagination(products.nbHits, products.nbPages, products.page);

                // update url to contain page index

                // make sure reloading page takes into account page number
              }
            }

            const pages = response.results[2];
            $('.search-advanced__pages p').remove();
            if(pages.nbHits > 0) {
              $('.search-advanced__pages').show();
              for(var i in pages.hits) {
                if(i < 3) {
                  $('.search-advanced__pages').append('<p><a href="/pages/'+pages.hits[i].handle+'">'+pages.hits[i].title+'</a></p>')
                }
              }
            }


            const news = response.results[3];
            $('.search-advanced__news .grid-row > div, .search-advanced__news .btn').remove();
            if(news.nbHits > 0) {
              $('.search-advanced__summary').show();
              $('.search-advanced__summary--news').text('NEWS ('+news.nbHits+')');
              if(products.nbHits == 0) {
                $('.search-advanced__news').show();
                $('.search-advanced__summary--active').removeClass('search-advanced__summary--active');
                $('.search-advanced__summary--news').addClass('search-advanced__summary--active');
              }
              for(var i in news.hits) {
                var article = news.hits[i];
                var utc = article.published_at;
                var date = new Date(utc);
                var finalDate = date.toLocaleString('EN-us', { month: 'long' }) + ' ' + date.getDate() + ', ' + date.getFullYear();
                $('.search-advanced__news .grid-row').append(`
                  <div class="article col-2 " style="">
              
                    <a href="/blogs/news/${article.handle}" class="image-portrait article__featured-image">
                      <img src="${article.image}" alt="AIMÉ LEON DORE GOLF®">
                    </a>
              
                    <div class="short-desc article__info">
                      <h3 class="article__title"><a href="/blogs/news/${article.handle}">${article.title}</a></h3>
                      <time class="article__date color-mg" date="04/23/25">${finalDate}</time>
                    </div>
                  </div>
                `)
              }
              if(news.nbHits > 10 && window.location.href.indexOf('/search') == -1) {
                $('.search-advanced__news').append('<a class="btn btn--dark" href="/search?aq='+searchTerm+'&type=news">View More</a>');
              }

              if(window.location.href.indexOf('/search') > -1) {
                let params = new URLSearchParams(document.location.search);
                let searchType = params.get('type');
                if(searchType == 'news') {
                  $('.search-advanced__summary--news').trigger('click');

                  const url = new URL(location);
                  url.searchParams.delete("type");
                  history.pushState({}, "", url);
                }
              }

              if (typeof gtag === 'function') {
                if(window.location.href.indexOf('search') > -1) {
                  // Search Page_Result_[blog name]
                  $('.search-advanced__news .article a').on('click', function (e) {
                    const blogName = $(this).parent().find('.article__title a').text().trim() || $(this).text().trim();
                    gtag('event', `Search Page_Result_${blogName}`);
                  });
                } else {
                  // Search_Result_[blog name]
                  $('.search-advanced__news .article a').on('click', function (e) {
                    const blogName = $(this).parent().find('.article__title a').text().trim() || $(this).text().trim();
                    gtag('event', `Search_Result_${blogName}`);
                  });
                }
              }
            }

            if(pages.nbHits == 0 && products.nbHits == 0 && news.nbHits == 0) {
              $('.search-advanced__noresults span').text(searchTerm);
              $('.search-advanced__noresults').show();
            }
            
          aldsearch.loadRecentlyViewed();

          }
        })
}, timeoutDelay);

      }



      // var data = {
      //   query: searchTerm
      // }
      // $('.search-advanced__suggestions *').remove();
      // $.ajax({
      //   url: 'https://PKR3QI1SD0.algolia.net/1/indexes/USDEV_products_query_suggestions_test/query',
      //   type: 'POST',
      //   headers: {
      //     'x-algolia-application-id': 'PKR3QI1SD0',
      //     'x-algolia-api-key': '5278ea88cf4f82e904297d1a101ed00f' 
      //   },
      //   data: JSON.stringify(data),
      //   success: function(response) {
      //     console.log('response suggestions: ', response);
      //     for(var i in response.hits) {
      //       $('.search-advanced__suggestions').append('<p>'+response.hits[i].query.replace(searchTerm, '<b>'+searchTerm+'</b>')+'</p>')
      //     }
      //   }
      // })

      // $('.search-advanced__products .grid-products *').remove();
      // $.ajax({
      //   url: 'https://PKR3QI1SD0.algolia.net/1/indexes/USDEV_products/query',
      //   type: 'POST',
      //   headers: {
      //     'x-algolia-application-id': 'PKR3QI1SD0',
      //     'x-algolia-api-key': '5278ea88cf4f82e904297d1a101ed00f' 
      //   },
      //   data: JSON.stringify(data),
      //   success: function(response) {
      //     console.log('response products: ', response);
      //     if(response.nbHits > 0) {
      //       $('.search-advanced__summary--products').text('SHOP ('+response.nbHits+')');
      //     }
      //     for(var i in response.hits) {
      //       var product = response.hits[i];
      //       console.log(product)
      //       $('.search-advanced__products .grid-products').append(`
      //         <a href="/products/${product.handle}" class="plp-product">
      //           <div class="image-4-5 product-image">
      //             <img src="${product.image}" />
      //           </div>
      //           <div class="temp-fix-scaling"></div><div class="short-desc plp-product__details">
      //             <h3 class="plp-product__title">${product.title}</h3>
      //             <div class="plp-product__price">
      //                 <span class="money">${product.price}</span>
      //             </div>
      //           </div>
      //         </a>
      //       `)
      //     }
      //   }
      // })

      // $('.search-advanced__news .grid-row *').remove();
      // $.ajax({
      //   url: 'https://PKR3QI1SD0.algolia.net/1/indexes/USDEV_articles/query',
      //   type: 'POST',
      //   headers: {
      //     'x-algolia-application-id': 'PKR3QI1SD0',
      //     'x-algolia-api-key': '5278ea88cf4f82e904297d1a101ed00f' 
      //   },
      //   data: JSON.stringify(data),
      //   success: function(response) {
      //     console.log('response articles: ', response);

      //   }
      // })

    },

    triggerSearchOnSearchPage: function() {
      if(window.location.href.indexOf('search') > -1) {
        let params = new URLSearchParams(document.location.search);
        let searchQuery = params.get('aq');
        let searchType = params.get('type');
        let searchPage = params.get('page');

        $('.search-advanced__input').val(searchQuery);
        aldsearch.searchTermChange();
      }
    },

    buildPagination: function(totalResults, totalPages, currentPage) {
      $('.search-advanced__products .pagination').remove();
      var paginationOutput = '';
      var prevArrowOutput = '';
      var nextArrowOutput = '';
      var pagesOutput = '';

      if(currentPage == 0) {
        prevArrowOutput = `
          <span class="prev pagination-disabled">
            <a></a>
          </span>`;
      } else {
        prevArrowOutput = `
          <span class="prev">
            <a href="#" data-searchpage="${currentPage}"></a>
          </span>`;
      }

      if(currentPage+1 == totalPages) {
        nextArrowOutput = `
          <span class="next pagination-disabled">
            <a></a>
          </span>`;
      } else {
        nextArrowOutput = `
          <span class="next">
            <a href="#" data-searchpage="${currentPage + 2}"></a>
          </span>`;
      }

      var displayPages = getPagination(currentPage+1, totalPages);

      for(let i = 0; i < displayPages.length; i++) {
        let numberDisplay = displayPages[i];
        if(numberDisplay < 10) {
          numberDisplay = '0'+numberDisplay;
        }
        if(currentPage+1 == displayPages[i]) {
          pagesOutput += `
            <span class="page current">${numberDisplay}</span>`;
        } else {
          if(displayPages[i] == '...') {
            pagesOutput += `<span class="page">...</span>`;
          } else {
            pagesOutput += `
              <span class="page">
                <a href="#" data-searchpage="${displayPages[i]}">${numberDisplay}</a>
              </span>`;    
          }
      
        }
      }

      paginationOutput = `
        <div class="pagination">
          ${prevArrowOutput}
          ${pagesOutput}
          ${nextArrowOutput}
        </div>`;

      $('.search-advanced__products').append(paginationOutput);
    }
  }

  // Expose so the PDP swatch quick-swap (templates/product.liquid) can rebuild the
  // "you may also like" recommendations for the newly selected colour.
  window.aldsearch = aldsearch;

  $(function () {
    aldsearch.init();
  });

})(jQuery);

function getPagination(currentPage, totalPages) {
    if (totalPages <= 1) return [1];
    
    const items = [];
    const current = Math.min(Math.max(1, currentPage), totalPages);
    
    // Always include first page
    items.push(1);
    
    if (totalPages <= 7) {
        // Show all pages if total is small
        for (let i = 2; i <= totalPages; i++) {
            items.push(i);
        }
    } else {
        // Complex pagination logic based on position
        if (current <= 4) {
            // Near the beginning: show pages 2 through current+2, then ellipsis, then last
            for (let i = 2; i <= Math.min(current + 2, 6); i++) {
                items.push(i);
            }
            items.push('...');
            items.push(totalPages);
        } else if (current >= totalPages - 2) {
            // Very close to end (last 3 pages): show last 5 pages
            items.push('...');
            for (let i = totalPages - 4; i <= totalPages; i++) {
                items.push(i);
            }
        } else if (current === totalPages - 3) {
            // Page 7 when total is 10: show last 6 pages
            items.push('...');
            for (let i = totalPages - 5; i <= totalPages; i++) {
                items.push(i);
            }
        } else {
            // In the middle: ellipsis, current-2 to current+2, ellipsis, last
            items.push('...');
            for (let i = current - 2; i <= current + 2; i++) {
                items.push(i);
            }
            items.push('...');
            items.push(totalPages);
        }
    }
    
    return items;
}

function reorderRecommendProducts(productsArray) {

  if(productsArray.length <= 16) {
    return productsArray;
  }

  let productTypes = {};
  let finalProductsArray = [];
  let surplusProductsArray = [];

  for(var i in productsArray) {
    const type = productsArray[i].product_type
    if(productTypes.hasOwnProperty(type)) {
      if(productTypes[type] < 3) {
        finalProductsArray.push(productsArray[i]);
      } else {
        surplusProductsArray.push(productsArray[i]);
      }
      productTypes[type] = productTypes[type] + 1;
    } else {
      productTypes[type] = 1;
      finalProductsArray.push(productsArray[i]);
    }
  }

  finalProductsArray = [...finalProductsArray, ...surplusProductsArray];

  return finalProductsArray;
}
